// AUTO-GENERATED by scripts/build-quiz.ts. DO NOT EDIT.
// Source: data/source.csv
// Generated: 2026-10-14T21:43:13.854Z

import type { Question, QuizManifest } from './quizTypes';

const QUESTIONS: Record<string, Question> = {
  "382984": {
    "id": "382984",
    "type": "_singleChoice",
    "title": "Which aspect of your past jobs did you <u>dislike the most</u>?",
    "description": "Think back on all your previous roles. What tasks, challenges, or work environments did you find <strong>unenjoyable or frustrating?</strong>",
    "variable": "dislikedJobAspect",
    "options": [
      {
        "id": "1379206",
        "text": "The work itself",
        "value": "work",
        "nextQuestionId": "383004"
      },
      {
        "id": "1379207",
        "text": "Negative work environment",
        "value": "environment",
        "nextQuestionId": "383004"
      },
      {
        "id": "1379208",
        "text": "Unsupportive management",
        "value": "management",
        "nextQuestionId": "383004"
      },
      {
        "id": "1379209",
        "text": "Difficult coworkers",
        "value": "coworkers",
        "nextQuestionId": "383004"
      },
      {
        "id": "1379210",
        "text": "Lack of advancement opportunities",
        "value": "opportunities",
        "nextQuestionId": "383004"
      },
      {
        "id": "1379211",
        "text": "Poor work-life balance",
        "value": "balance",
        "nextQuestionId": "383004"
      },
      {
        "id": "1379212",
        "text": "Low salary and benefits",
        "value": "salary",
        "nextQuestionId": "383004"
      },
      {
        "id": "1379213",
        "text": "Inflexible work schedule",
        "value": "flexibility",
        "nextQuestionId": "383004"
      },
      {
        "id": "1379214",
        "text": "Other",
        "value": "other",
        "nextQuestionId": "383005"
      }
    ],
    "branching": true,
    "skipping": true,
    "autoAdvance": true
  },
  "382985": {
    "id": "382985",
    "type": "_singleChoice",
    "title": "Which aspect of your past jobs did you <u>enjoy the most</u>?",
    "description": "Take a moment to reflect on all your previous roles. What tasks, responsibilities, or environments did you find <strong>most enjoyable or fulfilling?</strong>",
    "variable": "likedJobAspect",
    "options": [
      {
        "id": "1379215",
        "text": "The work itself was interesting",
        "value": "work",
        "nextQuestionId": "382984"
      },
      {
        "id": "1379216",
        "text": "Positive work environment",
        "value": "environment",
        "nextQuestionId": "382984"
      },
      {
        "id": "1379217",
        "text": "Supportive management",
        "value": "management",
        "nextQuestionId": "382984"
      },
      {
        "id": "1379218",
        "text": "Collaborative coworkers",
        "value": "coworkers",
        "nextQuestionId": "382984"
      },
      {
        "id": "1379219",
        "text": "Opportunities for advancement",
        "value": "opportunities",
        "nextQuestionId": "382984"
      },
      {
        "id": "1379220",
        "text": "Good work-life balance",
        "value": "balance",
        "nextQuestionId": "382984"
      },
      {
        "id": "1379221",
        "text": "High salary and benefits",
        "value": "salary",
        "nextQuestionId": "382984"
      },
      {
        "id": "1379222",
        "text": "Flexibility in work schedule",
        "value": "flexibility",
        "nextQuestionId": "382984"
      },
      {
        "id": "1379223",
        "text": "Other",
        "value": "other",
        "nextQuestionId": "383006"
      }
    ],
    "branching": true,
    "skipping": true,
    "autoAdvance": true
  },
  "382989": {
    "id": "382989",
    "type": "_singleChoice",
    "title": "Are you currently employed?",
    "variable": "employmentStatus",
    "options": [
      {
        "id": "1379238",
        "text": "Yes, full-time",
        "value": "fullTime",
        "nextQuestionId": "383292"
      },
      {
        "id": "1379239",
        "text": "Yes, part-time",
        "value": "partTime",
        "nextQuestionId": "383292"
      },
      {
        "id": "1379240",
        "text": "No, but actively seeking employment",
        "value": "searching",
        "nextQuestionId": "383212"
      },
      {
        "id": "1379241",
        "text": "No, and not currently seeking employment",
        "value": "notSearching",
        "nextQuestionId": "383212"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "382990": {
    "id": "382990",
    "type": "_singleChoice",
    "title": "What long-term career goal do you hope to achieve?",
    "description": "Your answer will help us prepare your personalized career roadmap.",
    "variable": "careerGoal",
    "options": [
      {
        "id": "1379242",
        "text": "Attaining a leadership position",
        "value": "leadership",
        "nextQuestionId": "383033"
      },
      {
        "id": "1379243",
        "text": "Becoming an expert in my field",
        "value": "expert",
        "nextQuestionId": "383033"
      },
      {
        "id": "1379244",
        "text": "Achieving a healthy work-life balance",
        "value": "balance",
        "nextQuestionId": "383033"
      },
      {
        "id": "1379245",
        "text": "Making a meaningful difference in the world",
        "value": "impact",
        "nextQuestionId": "383033"
      },
      {
        "id": "1379246",
        "text": "Achieving financial independence",
        "value": "independence",
        "nextQuestionId": "383033"
      },
      {
        "id": "1379247",
        "text": "Starting my own business",
        "value": "entrepreneur",
        "nextQuestionId": "383033"
      }
    ],
    "branching": true,
    "skipping": true,
    "autoAdvance": true
  },
  "382992": {
    "id": "382992",
    "type": "_singleChoice",
    "title": "How much student loan debt do you have?",
    "description": "Eligible users may qualify for exclusive loan forgiveness assistance.",
    "variable": "studentLoanAmount",
    "options": [
      {
        "id": "1379252",
        "text": "Less than $10,000",
        "value": "10000",
        "nextQuestionId": "383294"
      },
      {
        "id": "1379253",
        "text": "Between $10,001 and $25,000",
        "value": "25000",
        "nextQuestionId": "383294"
      },
      {
        "id": "1379254",
        "text": "Between $25,001 and $50,000",
        "value": "50000",
        "nextQuestionId": "383294"
      },
      {
        "id": "1379255",
        "text": "More than $50,000",
        "value": "100000",
        "nextQuestionId": "383294"
      }
    ],
    "branching": true,
    "skipping": true,
    "autoAdvance": true
  },
  "382994": {
    "id": "382994",
    "type": "_singleChoice",
    "title": "How do you feel about public speaking or giving presentations?",
    "variable": "fearPublicSpeaking",
    "options": [
      {
        "id": "1379259",
        "text": "Very comfortable",
        "value": "1",
        "nextQuestionId": "383043"
      },
      {
        "id": "1379260",
        "text": "Somewhat comfortable",
        "value": "2",
        "nextQuestionId": "383043"
      },
      {
        "id": "1379261",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383043"
      },
      {
        "id": "1379262",
        "text": "Somewhat uncomfortable",
        "value": "4",
        "nextQuestionId": "383043"
      },
      {
        "id": "1379263",
        "text": "Very uncomfortable",
        "value": "5",
        "nextQuestionId": "383043"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "382995": {
    "id": "382995",
    "type": "_multiChoice",
    "title": "What aspects of work, if any, make you feel uncertain or hesitant?",
    "description": "Please select all that apply.",
    "variable": "fearWorkAspects",
    "options": [
      {
        "id": "1379265",
        "text": "",
        "value": null,
        "nextQuestionId": "382994"
      },
      {
        "id": "1379264",
        "text": "Public speaking",
        "value": null,
        "nextQuestionId": "382994"
      },
      {
        "id": "1379267",
        "text": "High-pressure environments",
        "value": null,
        "nextQuestionId": "382994"
      },
      {
        "id": "1379266",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "382994",
        "noMatch": true
      },
      {
        "id": "1379268",
        "text": "Working with numbers or data",
        "value": null,
        "nextQuestionId": "382994"
      },
      {
        "id": "1379269",
        "text": "Traveling or relocation",
        "value": null,
        "nextQuestionId": "382994"
      },
      {
        "id": "1379270",
        "text": "Physical demands",
        "value": null,
        "nextQuestionId": "382994"
      },
      {
        "id": "1379271",
        "text": "Technology usage",
        "value": null,
        "nextQuestionId": "382994"
      },
      {
        "id": "1379272",
        "text": "Social interactions",
        "value": null,
        "nextQuestionId": "382994"
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": true
  },
  "382996": {
    "id": "382996",
    "type": "_transition",
    "title": "Remember, it's not you.",
    "description": "It's important to recognize that many factors affecting career advancement are beyond your control. We're here to help you navigate these challenges.",
    "variable": null,
    "options": [
      {
        "id": "1379273",
        "text": "Image",
        "value": null,
        "nextQuestionId": "382995"
      }
    ],
    "branching": false,
    "skipping": false,
    "autoAdvance": true
  },
  "382997": {
    "id": "382997",
    "type": "_singleChoice",
    "title": "Do you feel that external factors have hindered your career progression?",
    "variable": "externalFactors",
    "options": [
      {
        "id": "1379274",
        "text": "Yes, significantly",
        "value": "true",
        "nextQuestionId": "382996"
      },
      {
        "id": "1379275",
        "text": "Yes, somewhat",
        "value": "true",
        "nextQuestionId": "382996"
      },
      {
        "id": "1379276",
        "text": "No, not really",
        "value": "false",
        "nextQuestionId": "382996"
      },
      {
        "id": "1379277",
        "text": "Not sure",
        "value": "false",
        "nextQuestionId": "382996"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "382998": {
    "id": "382998",
    "type": "_freeText",
    "title": "What do you feel is preventing you from advancing in your career? (Other)",
    "description": "Please elaborate.",
    "variable": "careerBarrierOther",
    "options": [
      {
        "id": "1379278",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "382997",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": false
  },
  "382999": {
    "id": "382999",
    "type": "_freeText",
    "title": "What did you dislike about your manager(s)? (Other)",
    "description": "Please elaborate.",
    "variable": "managerConOther",
    "options": [
      {
        "id": "1379279",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383236",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": false
  },
  "383000": {
    "id": "383000",
    "type": "_multiChoice",
    "title": "What did you dislike about your manager(s)?",
    "description": "Please select all that apply.",
    "variable": "managerCon",
    "options": [
      {
        "id": "1379281",
        "text": "Other",
        "value": null,
        "nextQuestionId": "382999"
      },
      {
        "id": "1379280",
        "text": "Poor communication",
        "value": null,
        "nextQuestionId": "382999"
      },
      {
        "id": "1379283",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383236",
        "noMatch": true
      },
      {
        "id": "1379282",
        "text": "Micromanagement",
        "value": null,
        "nextQuestionId": "382999"
      },
      {
        "id": "1379284",
        "text": "Lack of support for my growth",
        "value": null,
        "nextQuestionId": "382999"
      },
      {
        "id": "1379285",
        "text": "Did not recognize my work",
        "value": null,
        "nextQuestionId": "382999"
      },
      {
        "id": "1379286",
        "text": "Unfair treatment",
        "value": null,
        "nextQuestionId": "382999"
      },
      {
        "id": "1379287",
        "text": "Created a negative work environment",
        "value": null,
        "nextQuestionId": "382999"
      }
    ],
    "branching": true,
    "skipping": true,
    "autoAdvance": true
  },
  "383001": {
    "id": "383001",
    "type": "_freeText",
    "title": "What did you like about your manager(s)? (Other)",
    "description": "Please elaborate.",
    "variable": "managerProOther",
    "options": [
      {
        "id": "1379289",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383000",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": false
  },
  "383002": {
    "id": "383002",
    "type": "_multiChoice",
    "title": "What did you like about your manager(s)?",
    "description": "Please select all that apply.",
    "variable": "managerPro",
    "options": [
      {
        "id": "1379291",
        "text": "Clear communication",
        "value": null,
        "nextQuestionId": "383000"
      },
      {
        "id": "1379290",
        "text": "Other",
        "value": null,
        "nextQuestionId": "383001"
      },
      {
        "id": "1379293",
        "text": "Provided constructive feedback",
        "value": null,
        "nextQuestionId": "383000"
      },
      {
        "id": "1379292",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383000",
        "noMatch": true
      },
      {
        "id": "1379294",
        "text": "Supported my professional growth",
        "value": null,
        "nextQuestionId": "383000"
      },
      {
        "id": "1379295",
        "text": "Recognized my contributions",
        "value": null,
        "nextQuestionId": "383000"
      },
      {
        "id": "1379296",
        "text": "Empowered me to make decisions",
        "value": null,
        "nextQuestionId": "383000"
      },
      {
        "id": "1379297",
        "text": "Fostered a positive team environment",
        "value": null,
        "nextQuestionId": "383000"
      }
    ],
    "branching": true,
    "skipping": true,
    "autoAdvance": true
  },
  "383003": {
    "id": "383003",
    "type": "_singleChoice",
    "title": "How would you describe your relationship with your current or most recent manager/supervisor?",
    "variable": "managerRelationship",
    "options": [
      {
        "id": "1379299",
        "text": "Excellent—supportive and encouraging",
        "value": "5",
        "nextQuestionId": "383002"
      },
      {
        "id": "1379300",
        "text": "Good—mostly positive interactions",
        "value": "4",
        "nextQuestionId": "383002"
      },
      {
        "id": "1379301",
        "text": "Fair—neutral relationship",
        "value": "3",
        "nextQuestionId": "383002"
      },
      {
        "id": "1379302",
        "text": "Poor—some conflicts or issues",
        "value": "2",
        "nextQuestionId": "383002"
      },
      {
        "id": "1379303",
        "text": "Very poor—significant conflicts or issues",
        "value": "1",
        "nextQuestionId": "383002"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383004": {
    "id": "383004",
    "type": "_freeText",
    "title": "What’s one thing no one knows about your past jobs?",
    "description": "We gather these insights to inspire others exploring similar career paths. Your response is optional.",
    "variable": "jobSecret",
    "options": [
      {
        "id": "1379304",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383003",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": false
  },
  "383005": {
    "id": "383005",
    "type": "_freeText",
    "title": "Which aspect of your past jobs did you dislike the most (other)?",
    "description": "Please elaborate.",
    "variable": "dislikedJobAspectOther",
    "options": [
      {
        "id": "1379305",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383004",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": false
  },
  "383006": {
    "id": "383006",
    "type": "_freeText",
    "title": "Which aspect of your past jobs did you enjoy the most (other)?",
    "description": "Please elaborate.",
    "variable": "likedJobAspectOther",
    "options": [
      {
        "id": "1379306",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "382984",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": false
  },
  "383007": {
    "id": "383007",
    "type": "_freeText",
    "title": "Would you like to elaborate so that we can understand you better?",
    "description": "This is optional.",
    "variable": "homeFeelingReason",
    "options": [
      {
        "id": "1379307",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383017",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": false
  },
  "383008": {
    "id": "383008",
    "type": "_singleChoice",
    "title": "Would you describe this influence as positive or negative?",
    "variable": "feelingTowardsHome",
    "options": [
      {
        "id": "1379308",
        "text": "Positive",
        "value": "positive",
        "nextQuestionId": "383007"
      },
      {
        "id": "1379309",
        "text": "Negative",
        "value": "negative",
        "nextQuestionId": "383007"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383009": {
    "id": "383009",
    "type": "_singleChoice",
    "title": "Has your family or home environment played a role in your career choice?",
    "variable": "homeInfluence",
    "options": [
      {
        "id": "1379310",
        "text": "Yes",
        "value": "true",
        "nextQuestionId": "383008"
      },
      {
        "id": "1379311",
        "text": "No",
        "value": "false",
        "nextQuestionId": "383172"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383010": {
    "id": "383010",
    "type": "_custom",
    "title": "Do you have a minimum target salary in mind?",
    "description": "We will try to stay as close to your target salary as possible with your criteria in mind.",
    "variable": "targetSalary",
    "options": [
      {
        "id": "1379312",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383265",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": false
  },
  "383011": {
    "id": "383011",
    "type": "_singleChoice",
    "title": "Would you be open to earning one or more online professional certificates to advance your career? 💼",
    "description": "Choosing <strong> No </strong> will exclude all jobs that explicitly require professional certificates that you do not currently have.",
    "variable": "certificateInterest",
    "options": [
      {
        "id": "1379313",
        "text": "✅ Yes",
        "value": "true",
        "nextQuestionId": "383146"
      },
      {
        "id": "1379314",
        "text": "❌ No",
        "value": "false",
        "nextQuestionId": "383146"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383013": {
    "id": "383013",
    "type": "_transition",
    "title": "🔁 Noticing repetitive questions?",
    "description": "Good catch! We employ a <strong>\"validity checking\"</strong> technique, a common method that encourages consistent and honest answers. It enhances the reliability of our analysis.",
    "variable": null,
    "options": [
      {
        "id": "1379320",
        "text": "Image",
        "value": null,
        "nextQuestionId": "383101",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1695132366619_graph.gif"
      }
    ],
    "branching": false,
    "skipping": false,
    "autoAdvance": true
  },
  "383015": {
    "id": "383015",
    "type": "_singleChoice",
    "title": "🎓 Are you currently a student?",
    "variable": "studentStatus",
    "options": [
      {
        "id": "1379333",
        "text": "No, I am not currently a student.",
        "value": "no",
        "nextQuestionId": "383206"
      },
      {
        "id": "1379334",
        "text": "Yes, I am in graduate school or beyond.",
        "value": "graduate",
        "nextQuestionId": "383037"
      },
      {
        "id": "1379335",
        "text": "Yes, I am in college or university.",
        "value": "college",
        "nextQuestionId": "383037"
      },
      {
        "id": "1379336",
        "text": "Yes, I am in high school.",
        "value": "high",
        "nextQuestionId": "383037"
      },
      {
        "id": "1379337",
        "text": "Yes, I am in middle school.",
        "value": "middle",
        "nextQuestionId": "383037"
      },
      {
        "id": "1379338",
        "text": "Yes, I am in elementary school.",
        "value": "elementary",
        "nextQuestionId": "383037"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383016": {
    "id": "383016",
    "type": "_transition",
    "title": "Almost done! 🎯 We just have a few questions left to finalize your report.",
    "description": "The following questions will help identify and align you with careers that are tailored specifically for you.",
    "variable": null,
    "options": [
      {
        "id": "1379339",
        "text": "Image",
        "value": null,
        "nextQuestionId": "383040",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1696948647673_6%20HD.gif"
      }
    ],
    "branching": false,
    "skipping": false,
    "autoAdvance": true
  },
  "383017": {
    "id": "383017",
    "type": "_singleChoice",
    "title": "Did your parents' occupations contribute significantly to this influence?",
    "variable": "parentJobInfluence",
    "options": [
      {
        "id": "1379340",
        "text": "Yes",
        "value": "true",
        "nextQuestionId": "383103"
      },
      {
        "id": "1379341",
        "text": "No",
        "value": "false",
        "nextQuestionId": "383172"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383018": {
    "id": "383018",
    "type": "_dropdown",
    "title": "What is your current or most recent job title?",
    "description": "If you can't find your job title, type \"Not Listed.\"",
    "variable": "currentJob",
    "options": [
      {
        "id": "1379342",
        "text": "Other",
        "value": null,
        "nextQuestionId": "383164"
      },
      {
        "id": "1379343",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383056",
        "noMatch": true
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383020": {
    "id": "383020",
    "type": "_singleChoice",
    "title": "Is this your first time taking a career test?",
    "variable": "firstTimeTest",
    "options": [
      {
        "id": "1379347",
        "text": "Yes, it's my first time.",
        "value": "true",
        "nextQuestionId": "383270"
      },
      {
        "id": "1379348",
        "text": "No, I have taken others.",
        "value": "false",
        "nextQuestionId": "383158"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true,
    "isEntry": true
  },
  "383021": {
    "id": "383021",
    "type": "_transition",
    "title": "You are not alone.",
    "description": "Many people share these feelings, and we're here to help you reach your next five-year goals.</strong>",
    "variable": null,
    "options": [
      {
        "id": "1379349",
        "text": "Image",
        "value": null,
        "nextQuestionId": "383140"
      }
    ],
    "branching": false,
    "skipping": false,
    "autoAdvance": true
  },
  "383022": {
    "id": "383022",
    "type": "_transition",
    "title": "How Do You Compare With Other JobTest.org Users?",
    "description": "Your strong persuasive skills place you in the top <strong>6%</strong>, underscoring the usefulness of this trait in the workplace.",
    "variable": null,
    "options": [
      {
        "id": "1379350",
        "text": "Image",
        "value": null,
        "nextQuestionId": "383180",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1692061411630_Persuasion%20Skills.png"
      }
    ],
    "branching": false,
    "skipping": false,
    "autoAdvance": true
  },
  "383023": {
    "id": "383023",
    "type": "_transition",
    "title": "How Do You Compare With Other JobTest.org Users?",
    "description": "Your leadership abilities place you in the top <strong>16%</strong>, setting you apart from the rest.",
    "variable": null,
    "options": [
      {
        "id": "1379351",
        "text": "Image",
        "value": null,
        "nextQuestionId": "383281",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1692061373258_Leadership.png"
      }
    ],
    "branching": false,
    "skipping": false,
    "autoAdvance": true
  },
  "383024": {
    "id": "383024",
    "type": "_freeText",
    "title": "Lastly, is there anything else we should be aware of while matching you with ideal careers?",
    "description": "If you have a physical or mental disability that could prevent you from holding certain jobs, please share that with us here.",
    "variable": "considerationUserInput",
    "options": [
      {
        "id": "1379352",
        "text": "No Match",
        "value": null,
        "nextQuestionId": null,
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": false,
    "isTerminal": true
  },
  "383025": {
    "id": "383025",
    "type": "_singleChoice",
    "title": "How do you feel about traveling for work? ✈️",
    "variable": "openToTravel",
    "options": [
      {
        "id": "1379353",
        "text": "I am open to a job with a significant amount of travel.",
        "value": "high",
        "nextQuestionId": "383144"
      },
      {
        "id": "1379354",
        "text": "I'm fine with occasional travel.",
        "value": "medium",
        "nextQuestionId": "383144"
      },
      {
        "id": "1379355",
        "text": "I prefer minimal travel for specific needs.",
        "value": "low",
        "nextQuestionId": "383144"
      },
      {
        "id": "1379356",
        "text": "I would prefer not to travel for work.",
        "value": "never",
        "nextQuestionId": "383144"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383026": {
    "id": "383026",
    "type": "_singleChoice",
    "title": "Are you open to relocating for work?",
    "description": "We will filter jobs based on your input.",
    "variable": "relocationPreference",
    "options": [
      {
        "id": "1379357",
        "text": "Yes, I'm open to relocation anywhere.",
        "value": "anywhere",
        "nextQuestionId": "383216"
      },
      {
        "id": "1379358",
        "text": "Yes, but only within my current country.",
        "value": "country",
        "nextQuestionId": "383216"
      },
      {
        "id": "1379359",
        "text": "Yes, but only within my current state or province.",
        "value": "state",
        "nextQuestionId": "383216"
      },
      {
        "id": "1379360",
        "text": "No, I would prefer to stay in my current city or town.",
        "value": "city",
        "nextQuestionId": "383216"
      },
      {
        "id": "1379361",
        "text": "I'm not sure, it would depend on the opportunity.",
        "value": "unsure",
        "nextQuestionId": "383216"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383027": {
    "id": "383027",
    "type": "_singleChoice",
    "title": "What work schedule do you prefer?",
    "variable": "preferredWorkSchedule",
    "options": [
      {
        "id": "1379362",
        "text": "Traditional 9-to-5 schedule",
        "value": "nineToFive",
        "nextQuestionId": "383026"
      },
      {
        "id": "1379363",
        "text": "Early bird schedule (starting and finishing early)",
        "value": "earlyBird",
        "nextQuestionId": "383026"
      },
      {
        "id": "1379364",
        "text": "Night owl schedule (starting and finishing late)",
        "value": "nightOwl",
        "nextQuestionId": "383026"
      },
      {
        "id": "1379365",
        "text": "Flexible schedule depending on my daily tasks",
        "value": "flexible",
        "nextQuestionId": "383026"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383028": {
    "id": "383028",
    "type": "_singleChoice",
    "title": "How do you feel about stress and pressure at work?",
    "variable": "stressTolerance",
    "options": [
      {
        "id": "1379366",
        "text": "I work best in a high-pressure environment with tight deadlines.",
        "value": "high",
        "nextQuestionId": "383032"
      },
      {
        "id": "1379367",
        "text": "I can handle some pressure but prefer a balanced workload.",
        "value": "medium",
        "nextQuestionId": "383032"
      },
      {
        "id": "1379368",
        "text": "I prefer a relaxed environment with minimal stress.",
        "value": "low",
        "nextQuestionId": "383032"
      }
    ],
    "branching": true,
    "skipping": true,
    "autoAdvance": true
  },
  "383029": {
    "id": "383029",
    "type": "_singleChoice",
    "title": "How do you prefer to receive feedback?",
    "variable": "preferredFeedbackStyle",
    "options": [
      {
        "id": "1379369",
        "text": "I prefer immediate, direct feedback.",
        "value": "direct",
        "nextQuestionId": "383027"
      },
      {
        "id": "1379370",
        "text": "I prefer a scheduled one-on-one feedback session.",
        "value": "private",
        "nextQuestionId": "383027"
      },
      {
        "id": "1379371",
        "text": "I like receiving feedback during team meetings.",
        "value": "team",
        "nextQuestionId": "383027"
      },
      {
        "id": "1379372",
        "text": "I appreciate feedback given in a written format, such as email.",
        "value": "written",
        "nextQuestionId": "383027"
      },
      {
        "id": "1379373",
        "text": "I'm open to any type of feedback mechanism.",
        "value": "any",
        "nextQuestionId": "383027"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383030": {
    "id": "383030",
    "type": "_singleChoice",
    "title": "What kind of leadership style do you respond to best?",
    "variable": "preferredLeadershipStyle",
    "options": [
      {
        "id": "1379374",
        "text": "Laissez-faire: I prefer leaders who give me space to work independently.",
        "value": "laissez",
        "nextQuestionId": "383029"
      },
      {
        "id": "1379375",
        "text": "Transformational: I like leaders who inspire and motivate through vision and enthusiasm.",
        "value": "transformational",
        "nextQuestionId": "383029"
      },
      {
        "id": "1379376",
        "text": "Transactional: I prefer leaders who provide clear expectations and reward or correct based on performance.",
        "value": "transactional",
        "nextQuestionId": "383029"
      },
      {
        "id": "1379377",
        "text": "Servant: I appreciate leaders who prioritize the team's needs and focus on creating a supportive environment.",
        "value": "servant",
        "nextQuestionId": "383029"
      },
      {
        "id": "1379378",
        "text": "Autocratic: I respond to leaders who make decisions quickly and provide clear direction.",
        "value": "autocratic",
        "nextQuestionId": "383029"
      }
    ],
    "branching": true,
    "skipping": true,
    "autoAdvance": true
  },
  "383031": {
    "id": "383031",
    "type": "_singleChoice",
    "title": "How much autonomy do you prefer in your work?",
    "variable": "autonomyPreference",
    "options": [
      {
        "id": "1379379",
        "text": "I prefer a high level of autonomy, managing all aspects of my work independently.",
        "value": "5",
        "nextQuestionId": "383030"
      },
      {
        "id": "1379380",
        "text": "I enjoy some autonomy, but appreciate guidance and occasional check-ins.",
        "value": "4",
        "nextQuestionId": "383030"
      },
      {
        "id": "1379381",
        "text": "I like a balanced approach with an equal mix of autonomy and supervision.",
        "value": "3",
        "nextQuestionId": "383030"
      },
      {
        "id": "1379382",
        "text": "I prefer regular supervision to keep me focused and on track.",
        "value": "2",
        "nextQuestionId": "383030"
      },
      {
        "id": "1379383",
        "text": "I work best with very close supervision and clear, step-by-step instructions.",
        "value": "1",
        "nextQuestionId": "383030"
      }
    ],
    "branching": true,
    "skipping": true,
    "autoAdvance": true
  },
  "383032": {
    "id": "383032",
    "type": "_singleChoice",
    "title": "Do you prefer to work in a small, medium, or large team?",
    "variable": "preferredTeamSize",
    "options": [
      {
        "id": "1379384",
        "text": "I work best alone.",
        "value": "alone",
        "nextQuestionId": "383031"
      },
      {
        "id": "1379385",
        "text": "I prefer a small team (2-5 people).",
        "value": "small",
        "nextQuestionId": "383031"
      },
      {
        "id": "1379386",
        "text": "I enjoy a medium-sized team (6-15 people).",
        "value": "medium",
        "nextQuestionId": "383031"
      },
      {
        "id": "1379387",
        "text": "I thrive in a large team (16-30a people).",
        "value": "large",
        "nextQuestionId": "383031"
      },
      {
        "id": "1379388",
        "text": "I like working in a team of 30 people or more (the bigger, the better).",
        "value": "huge",
        "nextQuestionId": "383031"
      }
    ],
    "branching": true,
    "skipping": true,
    "autoAdvance": true
  },
  "383033": {
    "id": "383033",
    "type": "_singleChoice",
    "title": "How do you approach risks in your career?",
    "variable": "riskTolerance",
    "options": [
      {
        "id": "1379389",
        "text": "I actively seek out new and risky opportunities.",
        "value": "high",
        "nextQuestionId": "383153"
      },
      {
        "id": "1379390",
        "text": "I'm open to risks if the potential rewards are high.",
        "value": "medium",
        "nextQuestionId": "383153"
      },
      {
        "id": "1379391",
        "text": "I take calculated risks when necessary.",
        "value": "low",
        "nextQuestionId": "383153"
      },
      {
        "id": "1379392",
        "text": "I prefer to avoid risks and stick with what's safe.",
        "value": "none",
        "nextQuestionId": "383153"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383037": {
    "id": "383037",
    "type": "_freeText",
    "title": "What school do you attend? (Optional)",
    "variable": "schoolName",
    "options": [
      {
        "id": "1379406",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383206",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": true
  },
  "383040": {
    "id": "383040",
    "type": "_singleChoice",
    "title": "What is your ethnicity?",
    "description": "We believe that having a diverse workforce is essential to the success of any organization. By understanding your ethnicity, we can better tailor our career report to meet your needs and goals.",
    "variable": "ethnicity",
    "options": [
      {
        "id": "1379415",
        "text": "Black or African American",
        "value": "african",
        "nextQuestionId": "999001"
      },
      {
        "id": "1379416",
        "text": "Asian",
        "value": "asian",
        "nextQuestionId": "999001"
      },
      {
        "id": "1379417",
        "text": "Hispanic/Latinx",
        "value": "hispanic",
        "nextQuestionId": "999001"
      },
      {
        "id": "1379418",
        "text": "Indigenous/Native American",
        "value": "native",
        "nextQuestionId": "999001"
      },
      {
        "id": "1379419",
        "text": "Middle Eastern/North African (MENA)",
        "value": "mena",
        "nextQuestionId": "999001"
      },
      {
        "id": "1379420",
        "text": "White/Caucasian",
        "value": "white",
        "nextQuestionId": "999001"
      },
      {
        "id": "1379421",
        "text": "None of the Above",
        "value": "none",
        "nextQuestionId": "999001"
      }
    ],
    "branching": true,
    "skipping": true,
    "autoAdvance": true
  },
  "383043": {
    "id": "383043",
    "type": "_dropdown",
    "title": "Do you have a job/career in mind that you are considering today?",
    "description": "We will provide in-depth insights into the job/career of your choice. If you don't see the desired option, please choose <strong> Not Listed</strong>. You will be able to write it on the next question.",
    "variable": "activelyExploringJob",
    "options": [
      {
        "id": "1379429",
        "text": "Other",
        "value": null,
        "nextQuestionId": "383044"
      },
      {
        "id": "1379430",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383095",
        "noMatch": true
      }
    ],
    "branching": true,
    "skipping": true,
    "autoAdvance": true
  },
  "383044": {
    "id": "383044",
    "type": "_freeText",
    "title": "Do you have a job/career in mind that you are considering today? (Other)",
    "description": "Please elaborate.",
    "variable": "activelyExploringJobOther",
    "options": [
      {
        "id": "1379431",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383095",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": true
  },
  "383056": {
    "id": "383056",
    "type": "_singleChoice",
    "title": "How many years of work experience do you have?",
    "description": "Include the total years of work experience across all roles, even if they’re from different industries or career transitions.",
    "variable": "yearsOfExperience",
    "options": [
      {
        "id": "1379474",
        "text": "Less than 1 year",
        "value": "1",
        "nextQuestionId": "383166"
      },
      {
        "id": "1379475",
        "text": "1 to 3 years",
        "value": "3",
        "nextQuestionId": "383166"
      },
      {
        "id": "1379476",
        "text": "3 to 7 years",
        "value": "7",
        "nextQuestionId": "383166"
      },
      {
        "id": "1379477",
        "text": "7 to 15 years",
        "value": "15",
        "nextQuestionId": "383166"
      },
      {
        "id": "1379478",
        "text": "More than 15 years",
        "value": "30",
        "nextQuestionId": "383166"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383057": {
    "id": "383057",
    "type": "_multiChoice",
    "title": "Do you have any of the following phobias?",
    "description": "Please select all that apply. If you don't have any, click <strong>NEXT</strong> to continue.",
    "variable": "phobia",
    "options": [
      {
        "id": "1379480",
        "text": "",
        "value": null,
        "nextQuestionId": "383221"
      },
      {
        "id": "1379479",
        "text": "🕷 Arachnophobia (Fear of Spiders)",
        "value": null,
        "nextQuestionId": "383221"
      },
      {
        "id": "1379482",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383221",
        "noMatch": true
      },
      {
        "id": "1379481",
        "text": "🗼 Acrophobia (Fear of Heights)",
        "value": null,
        "nextQuestionId": "383221"
      },
      {
        "id": "1379483",
        "text": "✈️ Aerophobia (Fear of Flying)",
        "value": null,
        "nextQuestionId": "383221"
      },
      {
        "id": "1379484",
        "text": "😵 Agoraphobia (Fear of Open or Crowded Spaces)",
        "value": null,
        "nextQuestionId": "383221"
      },
      {
        "id": "1379485",
        "text": "🐶 Cynophobia (Fear of Dogs)",
        "value": null,
        "nextQuestionId": "383221"
      },
      {
        "id": "1379486",
        "text": "🐍 Ophidiophobia (Fear of Snakes)",
        "value": null,
        "nextQuestionId": "383221"
      },
      {
        "id": "1379487",
        "text": "⚡️ Astraphobia (Fear of Thunder and Lightning)",
        "value": null,
        "nextQuestionId": "383221"
      },
      {
        "id": "1379488",
        "text": "🚪 Claustrophobia (Fear of Enclosed Spaces)",
        "value": null,
        "nextQuestionId": "383221"
      },
      {
        "id": "1379489",
        "text": "💉 Trypanophobia (Fear of Needles)",
        "value": null,
        "nextQuestionId": "383221"
      },
      {
        "id": "1379490",
        "text": "🦠️ Mysophobia (Fear of Germs and Contamination)",
        "value": null,
        "nextQuestionId": "383221"
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": true
  },
  "383058": {
    "id": "383058",
    "type": "_freeText",
    "title": "What other new activities or interests are you interested in exploring in your free time?",
    "description": "Please provide more details.",
    "variable": "futureHobbyOther",
    "options": [
      {
        "id": "1379491",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383057",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": true
  },
  "383070": {
    "id": "383070",
    "type": "_freeText",
    "title": "What school did you attend?",
    "description": "This is optional.",
    "variable": "schoolName",
    "options": [
      {
        "id": "1379538",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383138",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": true
  },
  "383071": {
    "id": "383071",
    "type": "_transition",
    "title": "We get it—balancing career and life is tough.",
    "description": "You're not alone, and <strong>it’s not your fault.</strong> We're here to help, just like we’ve helped 850,000 others.",
    "variable": null,
    "options": [
      {
        "id": "1379539",
        "text": "Image",
        "value": null,
        "nextQuestionId": "383235"
      }
    ],
    "branching": false,
    "skipping": false,
    "autoAdvance": true
  },
  "383072": {
    "id": "383072",
    "type": "_singleChoice",
    "title": "How often have these aspects been impacted by your career?",
    "variable": "careerDamageFrequency",
    "options": [
      {
        "id": "1379540",
        "text": "Very frequently",
        "value": "5",
        "nextQuestionId": "383071"
      },
      {
        "id": "1379541",
        "text": "Often",
        "value": "4",
        "nextQuestionId": "383071"
      },
      {
        "id": "1379542",
        "text": "Sometimes",
        "value": "3",
        "nextQuestionId": "383071"
      },
      {
        "id": "1379543",
        "text": "Rarely",
        "value": "2",
        "nextQuestionId": "383071"
      },
      {
        "id": "1379544",
        "text": "Never",
        "value": "1",
        "nextQuestionId": "383071"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383073": {
    "id": "383073",
    "type": "_freeText",
    "title": "Which areas of your personal life have been most affected? (Other)",
    "description": "Could you tell us more? (optional)",
    "variable": "personalLifeImpactDetailsOther",
    "options": [
      {
        "id": "1379545",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383072",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": false
  },
  "383074": {
    "id": "383074",
    "type": "_multiChoice",
    "title": "Which areas of your personal life have been most affected?",
    "description": "Please select all that apply.",
    "variable": "personalLifeImpactDetails",
    "options": [
      {
        "id": "1379547",
        "text": "Other",
        "value": null,
        "nextQuestionId": "383073"
      },
      {
        "id": "1379546",
        "text": "Family time",
        "value": null,
        "nextQuestionId": "383072"
      },
      {
        "id": "1379549",
        "text": "Missing important events (e.g., birthdays, anniversaries)",
        "value": null,
        "nextQuestionId": "383072"
      },
      {
        "id": "1379548",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383072",
        "noMatch": true
      },
      {
        "id": "1379550",
        "text": "Personal health and well-being",
        "value": null,
        "nextQuestionId": "383072"
      },
      {
        "id": "1379551",
        "text": "Relationships with friends",
        "value": null,
        "nextQuestionId": "383072"
      },
      {
        "id": "1379552",
        "text": "Pursuing hobbies and interests",
        "value": null,
        "nextQuestionId": "383072"
      }
    ],
    "branching": true,
    "skipping": true,
    "autoAdvance": true
  },
  "383075": {
    "id": "383075",
    "type": "_singleChoice",
    "title": "How has your most recent career impacted your personal life?",
    "variable": "personalLifeImpact",
    "options": [
      {
        "id": "1379554",
        "text": "Positive – Improved my life",
        "value": "positive",
        "nextQuestionId": "383235"
      },
      {
        "id": "1379555",
        "text": "Neutral – No real impact",
        "value": "neutral",
        "nextQuestionId": "383235"
      },
      {
        "id": "1379556",
        "text": "Negative – It has impacted my well-being",
        "value": "negativeWellBeing",
        "nextQuestionId": "383074"
      },
      {
        "id": "1379557",
        "text": "Negative – It has strained my relationships",
        "value": "negativeRelationship",
        "nextQuestionId": "383074"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383076": {
    "id": "383076",
    "type": "_singleChoice",
    "title": "What is your highest level of education?",
    "description": "We will show you available career paths tailored to your education level.",
    "variable": "educationLevel",
    "options": [
      {
        "id": "1379558",
        "text": "Some High School",
        "value": "1",
        "nextQuestionId": "383294"
      },
      {
        "id": "1379559",
        "text": "High School Diploma or Equivalent",
        "value": "2",
        "nextQuestionId": "383294"
      },
      {
        "id": "1379560",
        "text": "Some College",
        "value": "3",
        "nextQuestionId": "383234"
      },
      {
        "id": "1379561",
        "text": "Trade School",
        "value": "4",
        "nextQuestionId": "383234"
      },
      {
        "id": "1379562",
        "text": "Postsecondary Nondegree Award",
        "value": "5",
        "nextQuestionId": "383234"
      },
      {
        "id": "1379563",
        "text": "Associate's Degree (2-Year Program)",
        "value": "6",
        "nextQuestionId": "383234"
      },
      {
        "id": "1379564",
        "text": "Bachelor's Degree (4-Year Program)",
        "value": "7",
        "nextQuestionId": "383234"
      },
      {
        "id": "1379565",
        "text": "Master's Degree",
        "value": "8",
        "nextQuestionId": "383234"
      },
      {
        "id": "1379566",
        "text": "Doctoral or Professional Degree",
        "value": "9",
        "nextQuestionId": "383234"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383077": {
    "id": "383077",
    "type": "_singleChoice",
    "title": "I prefer a planned, organized approach rather than spontaneity.",
    "variable": "preferPlanning",
    "options": [
      {
        "id": "1379567",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383194"
      },
      {
        "id": "1379568",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383194"
      },
      {
        "id": "1379569",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383194"
      },
      {
        "id": "1379570",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383194"
      },
      {
        "id": "1379571",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383194"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383080": {
    "id": "383080",
    "type": "_multiDropdown",
    "title": "Are there any types of careers that you are absolutely NOT interested in?",
    "description": "Please select all that apply.",
    "variable": "undesiredFunction",
    "options": [
      {
        "id": "1379576",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383141",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": true
  },
  "383088": {
    "id": "383088",
    "type": "_singleChoice",
    "title": "Without overthinking your choice, please select the image that you prefer.",
    "variable": null,
    "options": [
      {
        "id": "1379588",
        "text": "chaos",
        "value": null,
        "nextQuestionId": "383268",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1702511111971_chaos_compressed.png"
      },
      {
        "id": "1379589",
        "text": "order",
        "value": null,
        "nextQuestionId": "383268",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1702511112088_order_compressed.png"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383089": {
    "id": "383089",
    "type": "_singleChoice",
    "title": "Without overthinking your choice, please select the image that you prefer.",
    "variable": null,
    "options": [
      {
        "id": "1379590",
        "text": "geometry",
        "value": null,
        "nextQuestionId": "383088",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1702511031078_geometry_compressed.png"
      },
      {
        "id": "1379591",
        "text": "architecture",
        "value": null,
        "nextQuestionId": "383088",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1702511031062_architecture_compressed.png"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383090": {
    "id": "383090",
    "type": "_transition",
    "title": "We've mapped out your profile.",
    "description": "Next, we will ask career-related questions to better understand your professional background and aspirations.",
    "variable": null,
    "options": [
      {
        "id": "1379592",
        "text": "Image",
        "value": null,
        "nextQuestionId": "382989",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1695132478552_transform.gif"
      }
    ],
    "branching": false,
    "skipping": false,
    "autoAdvance": true
  },
  "383091": {
    "id": "383091",
    "type": "_multiDropdown",
    "title": "What industry sector(s) have you previously worked in?",
    "description": "Please select all that apply.",
    "variable": "employmentIndustry",
    "options": [
      {
        "id": "1379593",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383093",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": true
  },
  "383093": {
    "id": "383093",
    "type": "_singleChoice",
    "title": "Would you like us to consider these industries when preparing our recommendations?",
    "description": "We can exclude your current industry sector(s) if you are looking for a complete transition. Your choice here will help us provide more tailored recommendations.",
    "variable": "employmentIndustryInclusion",
    "options": [
      {
        "id": "1379598",
        "text": "Yes, consider my current industry sector(s).",
        "value": "include",
        "nextQuestionId": "383018"
      },
      {
        "id": "1379599",
        "text": "No, exclude my current industry sector(s).",
        "value": "exclude",
        "nextQuestionId": "383018"
      },
      {
        "id": "1379600",
        "text": "I don't have a preference.",
        "value": "none",
        "nextQuestionId": "383018"
      },
      {
        "id": "1379601",
        "text": "Only include those I specify.",
        "value": "include",
        "nextQuestionId": "383125"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383094": {
    "id": "383094",
    "type": "_singleChoice",
    "title": "Are you currently claiming unemployment benefits?",
    "description": "Depending on your location, you could receive <strong>up to 50% of your base salary.</strong> \nAt the end of the quiz, you will have the option to speak to an expert to get assistance.",
    "variable": "unemploymentBenefitInfo",
    "options": [
      {
        "id": "1379602",
        "text": "Yes",
        "value": "yes",
        "nextQuestionId": "383293"
      },
      {
        "id": "1379603",
        "text": "No",
        "value": "no",
        "nextQuestionId": "383293"
      },
      {
        "id": "1379604",
        "text": "I'm not sure if I'm eligible",
        "value": "unsure",
        "nextQuestionId": "383293"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383095": {
    "id": "383095",
    "type": "_multiDropdown",
    "title": "If you could have any job in the world, what industry sector(s) would interest you?",
    "description": "Please select all that apply.",
    "variable": "desiredIndustry",
    "options": [
      {
        "id": "1379605",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383104",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": true
  },
  "383099": {
    "id": "383099",
    "type": "_transition",
    "title": "How Do You Compare With Other JobTest.org Users?",
    "description": "Your data analysis skills place you in the top <strong>10%</strong>, making you an ideal fit for many high-paying careers.",
    "variable": null,
    "options": [
      {
        "id": "1379617",
        "text": "Image",
        "value": null,
        "nextQuestionId": "383178",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1692061441261_Decision-Making.png"
      }
    ],
    "branching": false,
    "skipping": false,
    "autoAdvance": true
  },
  "383100": {
    "id": "383100",
    "type": "_singleChoice",
    "title": "What do you see in this image?",
    "description": "",
    "descriptionImageUrl": "https://jobtest-quiz-assets.s3.us-east-2.amazonaws.com/quiz-v3.0/woman_illusion.png",
    "variable": null,
    "options": [
      {
        "id": "1379618",
        "text": "Young Woman",
        "value": null,
        "nextQuestionId": "383117"
      },
      {
        "id": "1379619",
        "text": "Old Woman",
        "value": null,
        "nextQuestionId": "383117"
      },
      {
        "id": "1379620",
        "text": "Both",
        "value": null,
        "nextQuestionId": "383117"
      },
      {
        "id": "1379621",
        "text": "Other",
        "value": null,
        "nextQuestionId": "383117"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383101": {
    "id": "383101",
    "type": "_singleChoice",
    "title": "What do you see in this image?",
    "description": "",
    "descriptionImageUrl": "https://jobtest-quiz-assets.s3.us-east-2.amazonaws.com/quiz-v3.0/rubin_vase.jpg",
    "variable": null,
    "options": [
      {
        "id": "1379622",
        "text": "A Vase",
        "value": null,
        "nextQuestionId": "383100"
      },
      {
        "id": "1379623",
        "text": "Two Faces",
        "value": null,
        "nextQuestionId": "383100"
      },
      {
        "id": "1379624",
        "text": "Both",
        "value": null,
        "nextQuestionId": "383100"
      },
      {
        "id": "1379625",
        "text": "Other",
        "value": null,
        "nextQuestionId": "383100"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383102": {
    "id": "383102",
    "type": "_singleChoice",
    "title": "What do you see in this image?",
    "description": "",
    "descriptionImageUrl": "https://jobtest-quiz-assets.s3.us-east-2.amazonaws.com/quiz-v3.0/necker_cube.png",
    "variable": null,
    "options": [
      {
        "id": "1379626",
        "text": "The cube's front side is the bottom-left square.",
        "value": null,
        "nextQuestionId": "383189"
      },
      {
        "id": "1379627",
        "text": "The cube's front side is the upper-right square.",
        "value": null,
        "nextQuestionId": "383189"
      },
      {
        "id": "1379628",
        "text": "I see both perspectives.",
        "value": null,
        "nextQuestionId": "383189"
      },
      {
        "id": "1379629",
        "text": "I don't see either perspective.",
        "value": null,
        "nextQuestionId": "383189"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383103": {
    "id": "383103",
    "type": "_freeText",
    "title": "What do/did your parent(s) do for a living?",
    "description": "If your parent(s) had different or multiple jobs, please tell us which one most affected your job/career decision.",
    "variable": "parentJob",
    "options": [
      {
        "id": "1379630",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383172",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": true
  },
  "383104": {
    "id": "383104",
    "type": "_multiDropdown",
    "title": "Which types of careers interest you the most?",
    "description": "Please select all that apply.",
    "variable": "desiredFunction",
    "options": [
      {
        "id": "1379631",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383107",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": true
  },
  "383105": {
    "id": "383105",
    "type": "_freeText",
    "title": "Do any of your friends and family members' careers seem rewarding? If so, could you share why? (Optional)",
    "description": "The more we know about you, the better we can recommend the most suitable career options for you.",
    "variable": "fulfillingJobIdea",
    "options": [
      {
        "id": "1379632",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383267",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": false
  },
  "383107": {
    "id": "383107",
    "type": "_multiDropdown",
    "title": "Are there any industries that you are absolutely NOT interested in?",
    "description": "Please select all that apply.",
    "variable": "undesiredIndustry",
    "options": [
      {
        "id": "1379635",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383080",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": true
  },
  "383115": {
    "id": "383115",
    "type": "_custom",
    "title": "What is your current or most recent salary level?",
    "description": "We will compare your salary level with the potential salary of our recommended careers.",
    "variable": "currentSalary",
    "options": [
      {
        "id": "1379649",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383010",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": false,
    "autoAdvance": false
  },
  "383117": {
    "id": "383117",
    "type": "_singleChoice",
    "title": "What do you see in this image?",
    "description": "",
    "descriptionImageUrl": "https://jobtest-quiz-assets.s3.us-east-2.amazonaws.com/quiz-v3.0/duck_rabbit.png",
    "variable": null,
    "options": [
      {
        "id": "1379651",
        "text": "Duck",
        "value": null,
        "nextQuestionId": "383102"
      },
      {
        "id": "1379652",
        "text": "Rabbit",
        "value": null,
        "nextQuestionId": "383102"
      },
      {
        "id": "1379653",
        "text": "Both",
        "value": null,
        "nextQuestionId": "383102"
      },
      {
        "id": "1379654",
        "text": "Other",
        "value": null,
        "nextQuestionId": "383102"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383125": {
    "id": "383125",
    "type": "_multiDropdown",
    "title": "What industry sector(s) do you NOT want us to consider for our recommendations?",
    "description": "We will exclude these industries from our recommendations.",
    "variable": "employmentIndustryUndesired",
    "options": [
      {
        "id": "1379669",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383018",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": true
  },
  "383129": {
    "id": "383129",
    "type": "_singleChoice",
    "title": "I enjoy discussing theoretical and philosophical concepts.",
    "variable": "likeTheoryAndPhilosophy",
    "options": [
      {
        "id": "1379681",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383191"
      },
      {
        "id": "1379682",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383191"
      },
      {
        "id": "1379683",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383191"
      },
      {
        "id": "1379684",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383191"
      },
      {
        "id": "1379685",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383191"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383133": {
    "id": "383133",
    "type": "_singleChoice",
    "title": "I enjoy the freedom of keeping my options open rather than sticking to a schedule.",
    "variable": "dislikeSchedule",
    "options": [
      {
        "id": "1379701",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383251"
      },
      {
        "id": "1379702",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383251"
      },
      {
        "id": "1379703",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383251"
      },
      {
        "id": "1379704",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383251"
      },
      {
        "id": "1379705",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383251"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383137": {
    "id": "383137",
    "type": "_singleChoice",
    "title": "Are you in the position today that you thought you would be 5 years ago?",
    "variable": "fiveYear",
    "options": [
      {
        "id": "1379724",
        "text": "Yes",
        "value": "true",
        "nextQuestionId": "383021"
      },
      {
        "id": "1379725",
        "text": "No",
        "value": "false",
        "nextQuestionId": "383021"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383138": {
    "id": "383138",
    "type": "_singleChoice",
    "title": "Do you have any outstanding student loan debt?",
    "description": "For qualified individuals, we can help you reduce your debt.",
    "variable": "studentLoan",
    "options": [
      {
        "id": "1379726",
        "text": "Yes",
        "value": "true",
        "nextQuestionId": "382992"
      },
      {
        "id": "1379727",
        "text": "No",
        "value": "false",
        "nextQuestionId": "383294"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383139": {
    "id": "383139",
    "type": "_multiChoice",
    "title": "What were the reasons for your burnout?",
    "description": "Please select all that apply.",
    "variable": "burnoutReason",
    "options": [
      {
        "id": "1379728",
        "text": "",
        "value": null,
        "nextQuestionId": "383028"
      },
      {
        "id": "1379729",
        "text": "Unclear or excessive job expectations",
        "value": "job_expectation",
        "nextQuestionId": "383028"
      },
      {
        "id": "1379731",
        "text": "Lack of support from management",
        "value": "management_support",
        "nextQuestionId": "383028"
      },
      {
        "id": "1379730",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383028",
        "noMatch": true
      },
      {
        "id": "1379732",
        "text": "Lack of recognition or reward for hard work",
        "value": "no_reward",
        "nextQuestionId": "383028"
      },
      {
        "id": "1379733",
        "text": "Heavy workload or working long hours",
        "value": "long_hours",
        "nextQuestionId": "383028"
      },
      {
        "id": "1379734",
        "text": "Lack of work-life balance",
        "value": "balance",
        "nextQuestionId": "383028"
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": true
  },
  "383140": {
    "id": "383140",
    "type": "_singleChoice",
    "title": "Have you ever experienced burnout?",
    "variable": "burnoutExperience",
    "options": [
      {
        "id": "1379735",
        "text": "Yes",
        "value": "true",
        "nextQuestionId": "383139"
      },
      {
        "id": "1379736",
        "text": "No",
        "value": "false",
        "nextQuestionId": "383028"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383141": {
    "id": "383141",
    "type": "_freeText",
    "title": "What is a job/career that you admire but do NOT want to pursue? (Optional)",
    "description": "Common answers include social worker, surgeon, nurse, soldier, etc.",
    "variable": "admiredJob",
    "options": [
      {
        "id": "1379737",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383105",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": true
  },
  "383142": {
    "id": "383142",
    "type": "_transition",
    "title": "💡 Did you know?",
    "description": "67% of college-educated Americans have a career that is unrelated to their major.",
    "variable": null,
    "options": [
      {
        "id": "1379738",
        "text": "Image",
        "value": null,
        "nextQuestionId": "383188",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1710439067307_College_Major_Interstitial_Image_500x500.png"
      }
    ],
    "branching": false,
    "skipping": false,
    "autoAdvance": true
  },
  "383144": {
    "id": "383144",
    "type": "_singleChoice",
    "title": "How do you feel about the prospect of starting your own business or becoming an entrepreneur?",
    "variable": "startupInterest",
    "options": [
      {
        "id": "1379741",
        "text": "I am actively planning to start my own business.",
        "value": "current",
        "nextQuestionId": "383163"
      },
      {
        "id": "1379742",
        "text": "I've thought about it and would like to become an entrepreneur in the future.",
        "value": "high",
        "nextQuestionId": "383163"
      },
      {
        "id": "1379743",
        "text": "I'm intrigued by the idea but haven't made any concrete plans yet.",
        "value": "medium",
        "nextQuestionId": "383163"
      },
      {
        "id": "1379744",
        "text": "While I respect entrepreneurs, I prefer the stability of traditional employment.",
        "value": "low",
        "nextQuestionId": "383163"
      },
      {
        "id": "1379745",
        "text": "I haven't given it much thought.",
        "value": "unsure",
        "nextQuestionId": "383163"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383145": {
    "id": "383145",
    "type": "_singleChoice",
    "title": "Would you consider on-site training for your desired career, and for what maximum duration?",
    "description": "Most careers require a certain level of on-site training. Marking <strong>NO</strong> means we will <strong>only</strong> consider jobs for which you have a readily transferable skill set.",
    "variable": "trainingInterest",
    "options": [
      {
        "id": "1379746",
        "text": "No, I don't want any on-site training.",
        "value": "no",
        "nextQuestionId": "383115"
      },
      {
        "id": "1379747",
        "text": "Yes, I would consider short-term training of 3 months or less.",
        "value": "shortTerm",
        "nextQuestionId": "383115"
      },
      {
        "id": "1379748",
        "text": "Yes, I would consider medium-term training of 3 to 6 months.",
        "value": "moderateTerm",
        "nextQuestionId": "383115"
      },
      {
        "id": "1379749",
        "text": "Yes, I would consider long-term training of 6 months or more.",
        "value": "longTerm",
        "nextQuestionId": "383115"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383146": {
    "id": "383146",
    "type": "_singleChoice",
    "title": "Would you be open to enrolling in a training program to advance your career?",
    "description": "Some popular training programs include design, programming, cybersecurity, and AI, among others.",
    "variable": "trainingProgramInterest",
    "options": [
      {
        "id": "1379750",
        "text": "✅ Yes",
        "value": "true",
        "nextQuestionId": "383145"
      },
      {
        "id": "1379751",
        "text": "❌ No",
        "value": "false",
        "nextQuestionId": "383145"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383147": {
    "id": "383147",
    "type": "_freeText",
    "title": "In your free time, what other activities do you enjoy?",
    "description": "Please provide more details.",
    "variable": "currentHobbyOther",
    "options": [
      {
        "id": "1379752",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383211",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": true
  },
  "383148": {
    "id": "383148",
    "type": "_multiChoice",
    "title": "What do you enjoy doing in your free time?",
    "description": "Please select all that apply.",
    "variable": "currentHobby",
    "options": [
      {
        "id": "1379753",
        "text": "Reading",
        "value": "reading",
        "nextQuestionId": "383211"
      },
      {
        "id": "1379754",
        "text": "Other",
        "value": null,
        "nextQuestionId": "383147"
      },
      {
        "id": "1379756",
        "text": "Exercising or keeping fit",
        "value": "exercise",
        "nextQuestionId": "383211"
      },
      {
        "id": "1379755",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383211",
        "noMatch": true
      },
      {
        "id": "1379757",
        "text": "Cooking or baking",
        "value": "cooking",
        "nextQuestionId": "383211"
      },
      {
        "id": "1379758",
        "text": "Traveling or exploring new places",
        "value": "travel",
        "nextQuestionId": "383211"
      },
      {
        "id": "1379759",
        "text": "Engaging in arts and crafts",
        "value": "art",
        "nextQuestionId": "383211"
      },
      {
        "id": "1379760",
        "text": "Gaming (video, computer, or board games)",
        "value": "other",
        "nextQuestionId": "383147"
      },
      {
        "id": "1379761",
        "text": "Watching TV shows",
        "value": null,
        "nextQuestionId": "383211"
      },
      {
        "id": "1379762",
        "text": "Watching movies",
        "value": null,
        "nextQuestionId": "383211"
      },
      {
        "id": "1379763",
        "text": "Listening to music or attending concerts",
        "value": null,
        "nextQuestionId": "383211"
      }
    ],
    "branching": true,
    "skipping": true,
    "autoAdvance": true
  },
  "383149": {
    "id": "383149",
    "type": "_singleChoice",
    "title": "I am confident in my leadership abilities.",
    "variable": "leadershipConfidenceScore",
    "options": [
      {
        "id": "1379765",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383281"
      },
      {
        "id": "1379766",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383281"
      },
      {
        "id": "1379767",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383281"
      },
      {
        "id": "1379768",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383281"
      },
      {
        "id": "1379769",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383023"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383150": {
    "id": "383150",
    "type": "_singleChoice",
    "title": "I am comfortable giving presentations and can effectively communicate complex ideas to a group.",
    "variable": "presentationSkillsScore",
    "options": [
      {
        "id": "1379770",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383149"
      },
      {
        "id": "1379771",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383149"
      },
      {
        "id": "1379772",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383149"
      },
      {
        "id": "1379773",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383149"
      },
      {
        "id": "1379774",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383149"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383151": {
    "id": "383151",
    "type": "_singleChoice",
    "title": "I prefer an environment where research and analytical skills are highly valued.",
    "variable": "researchAnalyticalValue",
    "options": [
      {
        "id": "1379775",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383203"
      },
      {
        "id": "1379776",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383203"
      },
      {
        "id": "1379777",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383203"
      },
      {
        "id": "1379778",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383203"
      },
      {
        "id": "1379779",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383203"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383152": {
    "id": "383152",
    "type": "_singleChoice",
    "title": "I prefer work that requires thinking outside the box.",
    "variable": "creativeExpression",
    "options": [
      {
        "id": "1379780",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383148"
      },
      {
        "id": "1379781",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383148"
      },
      {
        "id": "1379782",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383148"
      },
      {
        "id": "1379783",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383148"
      },
      {
        "id": "1379784",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383148"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383153": {
    "id": "383153",
    "type": "_singleChoice",
    "title": "Are you interested in exploring how your personality aligns with potential career paths?",
    "description": "We'll ask a series of questions to understand your personality better, as this can be a key factor in achieving career satisfaction.",
    "variable": "personalitySkipped",
    "options": [
      {
        "id": "1379785",
        "text": "✅ Yes, let's explore my personality.",
        "value": "false",
        "nextQuestionId": "383252"
      },
      {
        "id": "1379786",
        "text": "❌ No, skip this section.",
        "value": "true",
        "nextQuestionId": "383276"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383154": {
    "id": "383154",
    "type": "_singleChoice",
    "title": "How do you feel about your personality changing in these interactions?",
    "variable": "personalityChangeFeeling",
    "options": [
      {
        "id": "1379787",
        "text": "It helps me adapt and succeed",
        "value": "like",
        "nextQuestionId": "383273"
      },
      {
        "id": "1379788",
        "text": "It makes me feel inauthentic",
        "value": "dislike",
        "nextQuestionId": "383273"
      },
      {
        "id": "1379789",
        "text": "I'm indifferent about it",
        "value": "neutral",
        "nextQuestionId": "383273"
      },
      {
        "id": "1379790",
        "text": "I hadn't noticed it before",
        "value": "neutral",
        "nextQuestionId": "383273"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383155": {
    "id": "383155",
    "type": "_singleChoice",
    "title": "Does your personality change based on who you’re interacting with at work?",
    "variable": "personalityChange",
    "options": [
      {
        "id": "1379791",
        "text": "Yes, often",
        "value": "true",
        "nextQuestionId": "383275"
      },
      {
        "id": "1379792",
        "text": "Sometimes",
        "value": "true",
        "nextQuestionId": "383275"
      },
      {
        "id": "1379793",
        "text": "Rarely",
        "value": "false",
        "nextQuestionId": "383273"
      },
      {
        "id": "1379794",
        "text": "No, I remain consistent",
        "value": "false",
        "nextQuestionId": "383273"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383156": {
    "id": "383156",
    "type": "_freeText",
    "title": "What brings you here to take our career test today? (Other)",
    "description": "Could you tell us more? (optional)",
    "variable": "test_taking_purpose_other",
    "options": [
      {
        "id": "1379795",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383075",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": false,
    "autoAdvance": false
  },
  "383157": {
    "id": "383157",
    "type": "_singleChoice",
    "title": "How satisfied were you with your previous career tests?",
    "variable": null,
    "options": [
      {
        "id": "1379796",
        "text": "Very Dissatisfied",
        "value": null,
        "nextQuestionId": "383274"
      },
      {
        "id": "1379797",
        "text": "Dissatisfied",
        "value": null,
        "nextQuestionId": "383274"
      },
      {
        "id": "1379798",
        "text": "Neutral",
        "value": null,
        "nextQuestionId": "383270"
      },
      {
        "id": "1379799",
        "text": "Satisfied",
        "value": null,
        "nextQuestionId": "383270"
      },
      {
        "id": "1379800",
        "text": "Very Satisfied",
        "value": null,
        "nextQuestionId": "383270"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383158": {
    "id": "383158",
    "type": "_multiChoice",
    "title": "Which career tests have you taken before?",
    "variable": "otherTest",
    "options": [
      {
        "id": "1379801",
        "text": "123test Career Test",
        "value": null,
        "nextQuestionId": "383157"
      },
      {
        "id": "1379802",
        "text": "",
        "value": null,
        "nextQuestionId": "383157"
      },
      {
        "id": "1379804",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383157",
        "noMatch": true
      },
      {
        "id": "1379803",
        "text": "ASA Futurescape",
        "value": null,
        "nextQuestionId": "383157"
      },
      {
        "id": "1379805",
        "text": "CareerExplorer",
        "value": null,
        "nextQuestionId": "383157"
      },
      {
        "id": "1379806",
        "text": "Strong Interest Inventory",
        "value": null,
        "nextQuestionId": "383157"
      },
      {
        "id": "1379807",
        "text": "Tryapt.ai",
        "value": null,
        "nextQuestionId": "383157"
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": true
  },
  "383161": {
    "id": "383161",
    "type": "_transition",
    "title": "How Do You Compare With Other JobTest.org Users?",
    "description": "Your ability to stay nimble and flexible is highly sought-after by employers, placing you in the top <strong>22%</strong> of your peer group.",
    "variable": null,
    "options": [
      {
        "id": "1379817",
        "text": "Image",
        "value": null,
        "nextQuestionId": "383175",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1692061481738_Adaptability.png"
      }
    ],
    "branching": false,
    "skipping": false,
    "autoAdvance": true
  },
  "383163": {
    "id": "383163",
    "type": "_singleChoice",
    "title": "How important is it for you to work in a job or sector that makes a positive social impact? 🌎",
    "variable": "socialImpactImportance",
    "options": [
      {
        "id": "1379819",
        "text": "Extremely important - it's a top priority for me.",
        "value": "5",
        "nextQuestionId": "383016"
      },
      {
        "id": "1379820",
        "text": "Very important - it strongly influences my career choices.",
        "value": "4",
        "nextQuestionId": "383016"
      },
      {
        "id": "1379821",
        "text": "Somewhat important - it's one factor among many I consider.",
        "value": "3",
        "nextQuestionId": "383016"
      },
      {
        "id": "1379822",
        "text": "Not very important - it's not a major factor in my career decisions.",
        "value": "2",
        "nextQuestionId": "383016"
      },
      {
        "id": "1379823",
        "text": "Not at all important - I don't consider it when making career decisions.",
        "value": "1",
        "nextQuestionId": "383016"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383164": {
    "id": "383164",
    "type": "_freeText",
    "title": "What is your job title? (Other)",
    "description": "Please specify your job title.",
    "variable": "currentJobOther",
    "options": [
      {
        "id": "1379824",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383056",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": false,
    "autoAdvance": true
  },
  "383166": {
    "id": "383166",
    "type": "_singleChoice",
    "title": "What made you choose your current job/career?",
    "variable": "jobDecisionReason",
    "options": [
      {
        "id": "1379831",
        "text": "Job security",
        "value": "security",
        "nextQuestionId": "383009"
      },
      {
        "id": "1379832",
        "text": "Work-life balance",
        "value": "balance",
        "nextQuestionId": "383009"
      },
      {
        "id": "1379833",
        "text": "Career advancement",
        "value": "advancement",
        "nextQuestionId": "383009"
      },
      {
        "id": "1379834",
        "text": "Work environment / culture / people",
        "value": "culture",
        "nextQuestionId": "383009"
      },
      {
        "id": "1379835",
        "text": "Needed a job to pay the bills",
        "value": "necessity",
        "nextQuestionId": "383009"
      },
      {
        "id": "1379836",
        "text": "Other (please specify)",
        "value": "other",
        "nextQuestionId": "383167"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383167": {
    "id": "383167",
    "type": "_freeText",
    "title": "What made you choose your current job/career? (Other)",
    "description": "Please tell us more.",
    "variable": "jobDecisionReasonOther",
    "options": [
      {
        "id": "1379837",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383009",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": true
  },
  "383171": {
    "id": "383171",
    "type": "_singleChoice",
    "title": "I am able to make tough decisions quickly and confidently.",
    "variable": "decisionMakingScore",
    "options": [
      {
        "id": "1379843",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383185"
      },
      {
        "id": "1379844",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383185"
      },
      {
        "id": "1379845",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383185"
      },
      {
        "id": "1379846",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383185"
      },
      {
        "id": "1379847",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383283"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383172": {
    "id": "383172",
    "type": "_singleChoice",
    "title": "What is the size of the organization you work/worked for?",
    "variable": "companySize",
    "options": [
      {
        "id": "1379848",
        "text": "Fewer than 10 people",
        "value": "10",
        "nextQuestionId": "383218"
      },
      {
        "id": "1379849",
        "text": "10 to 25 people",
        "value": "25",
        "nextQuestionId": "383218"
      },
      {
        "id": "1379850",
        "text": "26 to 100 people",
        "value": "100",
        "nextQuestionId": "383218"
      },
      {
        "id": "1379851",
        "text": "101 to 500 people",
        "value": "500",
        "nextQuestionId": "383218"
      },
      {
        "id": "1379852",
        "text": "501 to 1,000 people",
        "value": "1000",
        "nextQuestionId": "383218"
      },
      {
        "id": "1379853",
        "text": "More than 1,000 people",
        "value": "10000",
        "nextQuestionId": "383218"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383173": {
    "id": "383173",
    "type": "_singleChoice",
    "title": "I have technical skills in areas such as programming, engineering, or design.",
    "variable": "technicalSkillsScore",
    "options": [
      {
        "id": "1379854",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383224"
      },
      {
        "id": "1379855",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383224"
      },
      {
        "id": "1379856",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383224"
      },
      {
        "id": "1379857",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383224"
      },
      {
        "id": "1379858",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383224"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383174": {
    "id": "383174",
    "type": "_singleChoice",
    "title": "I am innovative and can think outside the box to solve challenges.",
    "variable": "innovationSkillsScore",
    "options": [
      {
        "id": "1379859",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383173"
      },
      {
        "id": "1379860",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383173"
      },
      {
        "id": "1379861",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383173"
      },
      {
        "id": "1379862",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383173"
      },
      {
        "id": "1379863",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383173"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383175": {
    "id": "383175",
    "type": "_singleChoice",
    "title": "I am a creative thinker and am able to come up with new ideas and approaches to problems.",
    "variable": "creativeThinkerScore",
    "options": [
      {
        "id": "1379864",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383174"
      },
      {
        "id": "1379865",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383174"
      },
      {
        "id": "1379866",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383174"
      },
      {
        "id": "1379867",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383174"
      },
      {
        "id": "1379868",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383174"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383176": {
    "id": "383176",
    "type": "_singleChoice",
    "title": "I am able to adapt to change quickly and effectively.",
    "variable": "changeAdaptationScore",
    "options": [
      {
        "id": "1379869",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383175"
      },
      {
        "id": "1379870",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383175"
      },
      {
        "id": "1379871",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383175"
      },
      {
        "id": "1379872",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383175"
      },
      {
        "id": "1379873",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383161"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383177": {
    "id": "383177",
    "type": "_singleChoice",
    "title": "I have strong interpersonal skills and excel at building relationships.",
    "variable": "interpersonalSkillsScore",
    "options": [
      {
        "id": "1379874",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383176"
      },
      {
        "id": "1379875",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383176"
      },
      {
        "id": "1379876",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383176"
      },
      {
        "id": "1379877",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383176"
      },
      {
        "id": "1379878",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383176"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383178": {
    "id": "383178",
    "type": "_singleChoice",
    "title": "I am skilled in project management and can plan and execute projects successfully.",
    "variable": "projectManagementScore",
    "options": [
      {
        "id": "1379879",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383177"
      },
      {
        "id": "1379880",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383177"
      },
      {
        "id": "1379881",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383177"
      },
      {
        "id": "1379882",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383177"
      },
      {
        "id": "1379883",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383177"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383179": {
    "id": "383179",
    "type": "_singleChoice",
    "title": "I have excellent customer service skills and am able to resolve complaints and concerns successfully.",
    "variable": "customerServiceSkills",
    "options": [
      {
        "id": "1379884",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383291"
      },
      {
        "id": "1379885",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383291"
      },
      {
        "id": "1379886",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383291"
      },
      {
        "id": "1379887",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383291"
      },
      {
        "id": "1379888",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383291"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383180": {
    "id": "383180",
    "type": "_singleChoice",
    "title": "I am a strong negotiator and can advocate for my interests effectively.",
    "variable": "negotiationSkillsScore",
    "options": [
      {
        "id": "1379889",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383179"
      },
      {
        "id": "1379890",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383179"
      },
      {
        "id": "1379891",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383179"
      },
      {
        "id": "1379892",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383179"
      },
      {
        "id": "1379893",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383179"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383181": {
    "id": "383181",
    "type": "_singleChoice",
    "title": "I am skilled at persuading others and making sales.",
    "variable": "salesSkillsScore",
    "options": [
      {
        "id": "1379894",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383180"
      },
      {
        "id": "1379895",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383180"
      },
      {
        "id": "1379896",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383180"
      },
      {
        "id": "1379897",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383180"
      },
      {
        "id": "1379898",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383022"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383182": {
    "id": "383182",
    "type": "_singleChoice",
    "title": "I am knowledgeable about marketing strategies and tactics.",
    "variable": "marketingKnowledgeScore",
    "options": [
      {
        "id": "1379899",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383181"
      },
      {
        "id": "1379900",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383181"
      },
      {
        "id": "1379901",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383181"
      },
      {
        "id": "1379902",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383181"
      },
      {
        "id": "1379903",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383181"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383183": {
    "id": "383183",
    "type": "_singleChoice",
    "title": "I have a strong understanding of financial management principles.",
    "variable": "financialManagementScore",
    "options": [
      {
        "id": "1379904",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383182"
      },
      {
        "id": "1379905",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383182"
      },
      {
        "id": "1379906",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383182"
      },
      {
        "id": "1379907",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383182"
      },
      {
        "id": "1379908",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383182"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383184": {
    "id": "383184",
    "type": "_singleChoice",
    "title": "I can manage my time effectively.",
    "variable": "timeManagementScore",
    "options": [
      {
        "id": "1379909",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383285"
      },
      {
        "id": "1379910",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383285"
      },
      {
        "id": "1379911",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383285"
      },
      {
        "id": "1379912",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383285"
      },
      {
        "id": "1379913",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383285"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383185": {
    "id": "383185",
    "type": "_singleChoice",
    "title": "I am a problem-solver and can find solutions to complex issues.",
    "variable": "problemSolvingScore",
    "options": [
      {
        "id": "1379914",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383184"
      },
      {
        "id": "1379915",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383184"
      },
      {
        "id": "1379916",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383184"
      },
      {
        "id": "1379917",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383184"
      },
      {
        "id": "1379918",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383184"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383187": {
    "id": "383187",
    "type": "_singleChoice",
    "title": "I am passionate about helping those who are in need.",
    "variable": "passionForHelping",
    "options": [
      {
        "id": "1379924",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383226"
      },
      {
        "id": "1379925",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383226"
      },
      {
        "id": "1379926",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383226"
      },
      {
        "id": "1379927",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383226"
      },
      {
        "id": "1379928",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383226"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383188": {
    "id": "383188",
    "type": "_singleChoice",
    "title": "I prefer a high-risk, high-reward environment with performance-based compensation.",
    "variable": "highRiskHighReward",
    "options": [
      {
        "id": "1379929",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383231"
      },
      {
        "id": "1379930",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383231"
      },
      {
        "id": "1379931",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383231"
      },
      {
        "id": "1379932",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383231"
      },
      {
        "id": "1379933",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383231"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383189": {
    "id": "383189",
    "type": "_singleChoice",
    "title": "I prefer tasks that require logical thinking rather than empathy.",
    "variable": "logicalOverEmpathetic",
    "options": [
      {
        "id": "1379934",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383133"
      },
      {
        "id": "1379935",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383133"
      },
      {
        "id": "1379936",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383133"
      },
      {
        "id": "1379937",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383133"
      },
      {
        "id": "1379938",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383133"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383190": {
    "id": "383190",
    "type": "_singleChoice",
    "title": "I am better at focusing on the details than seeing the big picture.",
    "variable": "detailFocus",
    "options": [
      {
        "id": "1379939",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383286"
      },
      {
        "id": "1379940",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383286"
      },
      {
        "id": "1379941",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383286"
      },
      {
        "id": "1379942",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383286"
      },
      {
        "id": "1379943",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383286"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383191": {
    "id": "383191",
    "type": "_singleChoice",
    "title": "I find more joy in helping others achieve their goals than in achieving my own.",
    "variable": "helpingOthersAchieve",
    "options": [
      {
        "id": "1379944",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383250"
      },
      {
        "id": "1379945",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383250"
      },
      {
        "id": "1379946",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383250"
      },
      {
        "id": "1379947",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383250"
      },
      {
        "id": "1379948",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383250"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383194": {
    "id": "383194",
    "type": "_singleChoice",
    "title": "I prefer tasks that require creativity.",
    "variable": "requiresCreativity",
    "options": [
      {
        "id": "1379959",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383142"
      },
      {
        "id": "1379960",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383142"
      },
      {
        "id": "1379961",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383142"
      },
      {
        "id": "1379962",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383142"
      },
      {
        "id": "1379963",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383142"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383201": {
    "id": "383201",
    "type": "_singleChoice",
    "title": "Without overthinking your choice, please select the image that you prefer.",
    "variable": null,
    "options": [
      {
        "id": "1379973",
        "text": "intangible",
        "value": null,
        "nextQuestionId": "383229",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1702511239625_intangible_compressed.png"
      },
      {
        "id": "1379974",
        "text": "reality",
        "value": null,
        "nextQuestionId": "383229",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1702511239444_reality_compressed.png"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383202": {
    "id": "383202",
    "type": "_singleChoice",
    "title": "I am not afraid to challenge conventional wisdom.",
    "variable": "nonconformist",
    "options": [
      {
        "id": "1379975",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383129"
      },
      {
        "id": "1379976",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383129"
      },
      {
        "id": "1379977",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383129"
      },
      {
        "id": "1379978",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383129"
      },
      {
        "id": "1379979",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383129"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383203": {
    "id": "383203",
    "type": "_singleChoice",
    "title": "I enjoy taking things apart to understand how they work.",
    "variable": "enjoysTakingApart",
    "options": [
      {
        "id": "1379980",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383232"
      },
      {
        "id": "1379981",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383232"
      },
      {
        "id": "1379982",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383232"
      },
      {
        "id": "1379983",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383232"
      },
      {
        "id": "1379984",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383232"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383204": {
    "id": "383204",
    "type": "_singleChoice",
    "title": "I can sometimes be too detail-oriented.",
    "variable": "detailOriented",
    "options": [
      {
        "id": "1379985",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383151"
      },
      {
        "id": "1379986",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383151"
      },
      {
        "id": "1379987",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383151"
      },
      {
        "id": "1379988",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383151"
      },
      {
        "id": "1379989",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383151"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383206": {
    "id": "383206",
    "type": "_singleChoice",
    "title": "Do you plan to enroll in college or graduate programs in the future?",
    "description": "We provide scholarships to qualified users.",
    "variable": "futureCollegeWhen",
    "options": [
      {
        "id": "1379995",
        "text": "No, I do not plan to enroll in college.",
        "value": "none",
        "nextQuestionId": "383267"
      },
      {
        "id": "1379996",
        "text": "Yes, but not for at least a year.",
        "value": "future",
        "nextQuestionId": "383267"
      },
      {
        "id": "1379997",
        "text": "Yes, within the next 12 months.",
        "value": "12mo",
        "nextQuestionId": "383267"
      },
      {
        "id": "1379998",
        "text": "Yes, within the next 6 months.",
        "value": "6mo",
        "nextQuestionId": "383267"
      },
      {
        "id": "1379999",
        "text": "Yes, within the next 3 months.",
        "value": "3mo",
        "nextQuestionId": "383267"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383207": {
    "id": "383207",
    "type": "_singleChoice",
    "title": "I prefer to work alone.",
    "variable": "prefersWorkingAlone",
    "options": [
      {
        "id": "1380000",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383152"
      },
      {
        "id": "1380001",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383152"
      },
      {
        "id": "1380002",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383152"
      },
      {
        "id": "1380003",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383152"
      },
      {
        "id": "1380004",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383152"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383208": {
    "id": "383208",
    "type": "_singleChoice",
    "title": "I am great at persuading others to support my ideas.",
    "variable": "persuasiveSkills",
    "options": [
      {
        "id": "1380005",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383013"
      },
      {
        "id": "1380006",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383013"
      },
      {
        "id": "1380007",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383013"
      },
      {
        "id": "1380008",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383013"
      },
      {
        "id": "1380009",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383013"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383209": {
    "id": "383209",
    "type": "_singleChoice",
    "title": "I prefer to find my own answers rather than relying on others with more experience.",
    "variable": "selfReliance",
    "options": [
      {
        "id": "1380010",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383225"
      },
      {
        "id": "1380011",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383225"
      },
      {
        "id": "1380012",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383225"
      },
      {
        "id": "1380013",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383225"
      },
      {
        "id": "1380014",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383225"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383210": {
    "id": "383210",
    "type": "_singleChoice",
    "title": "I have a keen interest in understanding the inner workings of machines.",
    "variable": "interestedInMachines",
    "options": [
      {
        "id": "1380015",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383202"
      },
      {
        "id": "1380016",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383202"
      },
      {
        "id": "1380017",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383202"
      },
      {
        "id": "1380018",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383202"
      },
      {
        "id": "1380019",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383202"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383211": {
    "id": "383211",
    "type": "_multiChoice",
    "title": "Are there any new activities or interests you'd like to explore in your free time?",
    "description": "Please select all that apply.",
    "variable": "futureHobby",
    "options": [
      {
        "id": "1380021",
        "text": "Learning a new language",
        "value": "language",
        "nextQuestionId": "383244"
      },
      {
        "id": "1380023",
        "text": "Picking up a new sport",
        "value": "sport",
        "nextQuestionId": "383248"
      },
      {
        "id": "1380024",
        "text": "Playing a musical instrument",
        "value": "music",
        "nextQuestionId": "383246"
      },
      {
        "id": "1380026",
        "text": "Trying painting or drawing",
        "value": "paint",
        "nextQuestionId": "383057"
      },
      {
        "id": "1380029",
        "text": "Delving into photography",
        "value": "photography",
        "nextQuestionId": "383057"
      },
      {
        "id": "1380030",
        "text": "Traveling to new places",
        "value": "travel",
        "nextQuestionId": "383057"
      },
      {
        "id": "1380031",
        "text": "Discovering new literary genres or authors",
        "value": "reading",
        "nextQuestionId": "383057"
      },
      {
        "id": "1380032",
        "text": "Exploring writing (e.g., fiction, blogging)",
        "value": "writing",
        "nextQuestionId": "383057"
      },
      {
        "id": "1380033",
        "text": "Other",
        "value": "other",
        "nextQuestionId": "383058"
      },
      {
        "id": "1380028",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383057",
        "noMatch": true
      }
    ],
    "branching": true,
    "skipping": true,
    "autoAdvance": true
  },
  "383212": {
    "id": "383212",
    "type": "_singleChoice",
    "title": "Have you been employed before?",
    "variable": "employmentHistory",
    "options": [
      {
        "id": "1380034",
        "text": "Yes",
        "value": "true",
        "nextQuestionId": "383213"
      },
      {
        "id": "1380035",
        "text": "No",
        "value": "false",
        "nextQuestionId": "383015"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383213": {
    "id": "383213",
    "type": "_singleChoice",
    "title": "How long have you been unemployed for?",
    "variable": "unemploymentLength",
    "options": [
      {
        "id": "1380036",
        "text": "Less than 1 month",
        "value": "1mo",
        "nextQuestionId": "383094"
      },
      {
        "id": "1380037",
        "text": "1 to 3 months",
        "value": "3mo",
        "nextQuestionId": "383094"
      },
      {
        "id": "1380038",
        "text": "3 to 6 months",
        "value": "6mo",
        "nextQuestionId": "383293"
      },
      {
        "id": "1380039",
        "text": "6 to 12 months",
        "value": "12mo",
        "nextQuestionId": "383293"
      },
      {
        "id": "1380040",
        "text": "12 to 24 months",
        "value": "18mo",
        "nextQuestionId": "383293"
      },
      {
        "id": "1380041",
        "text": "More than 24 months",
        "value": "24mo",
        "nextQuestionId": "383293"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383216": {
    "id": "383216",
    "type": "_singleChoice",
    "title": "How important is having the option to work from home (WFH)? 🏠",
    "variable": "workFromHome",
    "options": [
      {
        "id": "1380044",
        "text": "It's a must (non-negotiable).",
        "value": "must",
        "nextQuestionId": "383025"
      },
      {
        "id": "1380045",
        "text": "It's important, but not a deal-breaker.",
        "value": "important",
        "nextQuestionId": "383025"
      },
      {
        "id": "1380046",
        "text": "It doesn't matter to me.",
        "value": "neutral",
        "nextQuestionId": "383025"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383217": {
    "id": "383217",
    "type": "_singleChoice",
    "title": "What is your age?",
    "description": "We will show you potential career progressions that are appropriate for your age.",
    "variable": "currentAge",
    "options": [
      {
        "id": "1380047",
        "text": "0-13",
        "value": "13",
        "nextQuestionId": "383076"
      },
      {
        "id": "1380048",
        "text": "14-18",
        "value": "18",
        "nextQuestionId": "383076"
      },
      {
        "id": "1380049",
        "text": "19-24",
        "value": "24",
        "nextQuestionId": "383076"
      },
      {
        "id": "1380050",
        "text": "25-29",
        "value": "29",
        "nextQuestionId": "383076"
      },
      {
        "id": "1380051",
        "text": "30-39",
        "value": "39",
        "nextQuestionId": "383076"
      },
      {
        "id": "1380052",
        "text": "40-49",
        "value": "49",
        "nextQuestionId": "383076"
      },
      {
        "id": "1380053",
        "text": "50-59",
        "value": "59",
        "nextQuestionId": "383076"
      },
      {
        "id": "1380054",
        "text": "60+",
        "value": "60",
        "nextQuestionId": "383076"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383218": {
    "id": "383218",
    "type": "_singleChoice",
    "title": "How many hours do/did you work per week?",
    "variable": "weeklyHoursWorked",
    "options": [
      {
        "id": "1380055",
        "text": "Fewer than 40 hours",
        "value": "20",
        "nextQuestionId": "382985"
      },
      {
        "id": "1380056",
        "text": "40 - 50 hours",
        "value": "45",
        "nextQuestionId": "382985"
      },
      {
        "id": "1380057",
        "text": "51 - 60 hours",
        "value": "55",
        "nextQuestionId": "382985"
      },
      {
        "id": "1380058",
        "text": "61 - 70 hours",
        "value": "65",
        "nextQuestionId": "382985"
      },
      {
        "id": "1380059",
        "text": "71 - 80 hours",
        "value": "75",
        "nextQuestionId": "382985"
      },
      {
        "id": "1380060",
        "text": "More than 80 hours ☠️",
        "value": "100",
        "nextQuestionId": "382985"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383221": {
    "id": "383221",
    "type": "_transition",
    "title": "Your Career Personality (CAPBOI) has been mapped out.",
    "description": "<strong>CAPBOI</strong> is our proprietary personality evaluation tool backed by over 750,000 users, where we account for your personality traits as they relate to your career choices.",
    "variable": null,
    "options": [
      {
        "id": "1380068",
        "text": "Image",
        "value": null,
        "nextQuestionId": "383278",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1695134744249_CAPBOI.gif"
      }
    ],
    "branching": false,
    "skipping": false,
    "autoAdvance": true
  },
  "383222": {
    "id": "383222",
    "type": "_singleChoice",
    "title": "I am a strong researcher and can gather and analyze information from various sources.",
    "variable": "researchSkillsScore",
    "options": [
      {
        "id": "1380069",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383090"
      },
      {
        "id": "1380070",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383090"
      },
      {
        "id": "1380071",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383090"
      },
      {
        "id": "1380072",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383090"
      },
      {
        "id": "1380073",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383090"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383223": {
    "id": "383223",
    "type": "_singleChoice",
    "title": "I am skilled at statistical analysis and can effectively analyze and interpret data.",
    "variable": "statisticalAnalysisScore",
    "options": [
      {
        "id": "1380074",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383222"
      },
      {
        "id": "1380075",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383222"
      },
      {
        "id": "1380076",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383222"
      },
      {
        "id": "1380077",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383222"
      },
      {
        "id": "1380078",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383222"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383224": {
    "id": "383224",
    "type": "_singleChoice",
    "title": "I am proficient in using computer software and tools.",
    "variable": "computerProficiencyScore",
    "options": [
      {
        "id": "1380079",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383223"
      },
      {
        "id": "1380080",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383223"
      },
      {
        "id": "1380081",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383223"
      },
      {
        "id": "1380082",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383223"
      },
      {
        "id": "1380083",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383223"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383225": {
    "id": "383225",
    "type": "_singleChoice",
    "title": "I prefer work environments where success metrics are clearly defined.",
    "variable": "clearSuccessMetrics",
    "options": [
      {
        "id": "1380084",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383227"
      },
      {
        "id": "1380085",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383227"
      },
      {
        "id": "1380086",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383227"
      },
      {
        "id": "1380087",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383227"
      },
      {
        "id": "1380088",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383227"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383226": {
    "id": "383226",
    "type": "_singleChoice",
    "title": "I consider myself more practical than inventive.",
    "variable": "practicalOverInventive",
    "options": [
      {
        "id": "1380089",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383208"
      },
      {
        "id": "1380090",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383208"
      },
      {
        "id": "1380091",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383208"
      },
      {
        "id": "1380092",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383208"
      },
      {
        "id": "1380093",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383208"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383227": {
    "id": "383227",
    "type": "_singleChoice",
    "title": "I like to structure and plan my day.",
    "variable": "organizedPlanner",
    "options": [
      {
        "id": "1380094",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383230"
      },
      {
        "id": "1380095",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383230"
      },
      {
        "id": "1380096",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383230"
      },
      {
        "id": "1380097",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383230"
      },
      {
        "id": "1380098",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383230"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383228": {
    "id": "383228",
    "type": "_singleChoice",
    "title": "I prefer to work with people who rely on reasoning rather than emotion.",
    "variable": "frustratedByEmotions",
    "options": [
      {
        "id": "1380099",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383290"
      },
      {
        "id": "1380100",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383290"
      },
      {
        "id": "1380101",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383290"
      },
      {
        "id": "1380102",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383290"
      },
      {
        "id": "1380103",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383290"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383229": {
    "id": "383229",
    "type": "_singleChoice",
    "title": "I dislike competing with others.",
    "variable": "dislikesCompetition",
    "options": [
      {
        "id": "1380104",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383204"
      },
      {
        "id": "1380105",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383204"
      },
      {
        "id": "1380106",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383204"
      },
      {
        "id": "1380107",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383204"
      },
      {
        "id": "1380108",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383204"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383230": {
    "id": "383230",
    "type": "_singleChoice",
    "title": "I enjoy pondering philosophical questions.",
    "variable": "enjoysPhilosophicalQuestions",
    "options": [
      {
        "id": "1380109",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383284"
      },
      {
        "id": "1380110",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383284"
      },
      {
        "id": "1380111",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383284"
      },
      {
        "id": "1380112",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383284"
      },
      {
        "id": "1380113",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383284"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383231": {
    "id": "383231",
    "type": "_singleChoice",
    "title": "I am often the leader of the group.",
    "variable": "groupLeader",
    "options": [
      {
        "id": "1380114",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383207"
      },
      {
        "id": "1380115",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383207"
      },
      {
        "id": "1380116",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383207"
      },
      {
        "id": "1380117",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383207"
      },
      {
        "id": "1380118",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383207"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383232": {
    "id": "383232",
    "type": "_singleChoice",
    "title": "I enjoy researching and delving deeply into a subject.",
    "variable": "enjoysDeepResearch",
    "options": [
      {
        "id": "1380119",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383077"
      },
      {
        "id": "1380120",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383077"
      },
      {
        "id": "1380121",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383077"
      },
      {
        "id": "1380122",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383077"
      },
      {
        "id": "1380123",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383077"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383233": {
    "id": "383233",
    "type": "_singleChoice",
    "title": "I am more of a morning person than a night owl.",
    "variable": "morningPerson",
    "options": [
      {
        "id": "1380124",
        "text": "Strongly Disagree (I'm a total night owl)",
        "value": "1",
        "nextQuestionId": "383209"
      },
      {
        "id": "1380125",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383209"
      },
      {
        "id": "1380126",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383209"
      },
      {
        "id": "1380127",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383209"
      },
      {
        "id": "1380128",
        "text": "Strongly Agree (I'm definitely a morning person)",
        "value": "5",
        "nextQuestionId": "383209"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383234": {
    "id": "383234",
    "type": "_multiDropdown",
    "title": "What was your school major? 🎓",
    "description": "Select the major that is closest to what you studied in <u>your most advanced degree</u>.",
    "variable": "schoolMajor",
    "options": [
      {
        "id": "1380129",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383070",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": false,
    "autoAdvance": true
  },
  "383235": {
    "id": "383235",
    "type": "_singleChoice",
    "title": "What does work-life balance mean to you?",
    "variable": "balanceMeaning",
    "options": [
      {
        "id": "1380130",
        "text": "Clear separation between work and personal time",
        "value": "separation",
        "nextQuestionId": "383272"
      },
      {
        "id": "1380131",
        "text": "Flexibility to manage both work and personal commitments",
        "value": "flexibility",
        "nextQuestionId": "383272"
      },
      {
        "id": "1380132",
        "text": "Prioritizing personal life over work",
        "value": "morePersonal",
        "nextQuestionId": "383272"
      },
      {
        "id": "1380133",
        "text": "Integrating work seamlessly into my life",
        "value": "integrated",
        "nextQuestionId": "383272"
      }
    ],
    "branching": true,
    "skipping": true,
    "autoAdvance": true
  },
  "383236": {
    "id": "383236",
    "type": "_singleChoice",
    "title": "What do you feel is preventing you from advancing in your career?",
    "description": "Please select <strong>one</strong> option that best describes your situation.",
    "variable": "careerBarrier",
    "options": [
      {
        "id": "1380134",
        "text": "Lack of opportunities in my current organization",
        "value": "opportunities",
        "nextQuestionId": "382997"
      },
      {
        "id": "1380135",
        "text": "Limited education or qualifications",
        "value": "education",
        "nextQuestionId": "382997"
      },
      {
        "id": "1380136",
        "text": "Workplace politics",
        "value": "workplace",
        "nextQuestionId": "382997"
      },
      {
        "id": "1380137",
        "text": "Glass ceiling (e.g., discrimination, bias)",
        "value": "discrimination",
        "nextQuestionId": "382997"
      },
      {
        "id": "1380138",
        "text": "Unsupportive management",
        "value": "management",
        "nextQuestionId": "382997"
      },
      {
        "id": "1380139",
        "text": "Economic factors (e.g., industry downturn)",
        "value": "economic",
        "nextQuestionId": "382997"
      },
      {
        "id": "1380140",
        "text": "Personal circumstances (e.g., family obligations)",
        "value": "family",
        "nextQuestionId": "382997"
      },
      {
        "id": "1380141",
        "text": "Other",
        "value": "other",
        "nextQuestionId": "382998"
      }
    ],
    "branching": true,
    "skipping": true,
    "autoAdvance": true
  },
  "383237": {
    "id": "383237",
    "type": "_singleChoice",
    "title": "I am highly organized.",
    "variable": "organizationalSkillsScore",
    "options": [
      {
        "id": "1380142",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383282"
      },
      {
        "id": "1380143",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383282"
      },
      {
        "id": "1380144",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383282"
      },
      {
        "id": "1380145",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383282"
      },
      {
        "id": "1380146",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383282"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383244": {
    "id": "383244",
    "type": "_multiChoice",
    "title": "Which of these languages would you be interested in learning?",
    "description": "Please select all that apply.",
    "variable": "futureHobbyLanguage",
    "options": [
      {
        "id": "1380169",
        "text": "Other",
        "value": null,
        "nextQuestionId": "383245"
      },
      {
        "id": "1380170",
        "text": "Spanish",
        "value": null,
        "nextQuestionId": "383057"
      },
      {
        "id": "1380172",
        "text": "French",
        "value": null,
        "nextQuestionId": "383057"
      },
      {
        "id": "1380171",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383057",
        "noMatch": true
      },
      {
        "id": "1380173",
        "text": "Chinese",
        "value": null,
        "nextQuestionId": "383057"
      },
      {
        "id": "1380174",
        "text": "German",
        "value": null,
        "nextQuestionId": "383057"
      },
      {
        "id": "1380175",
        "text": "Italian",
        "value": null,
        "nextQuestionId": "383057"
      },
      {
        "id": "1380176",
        "text": "Japanese",
        "value": null,
        "nextQuestionId": "383057"
      },
      {
        "id": "1380177",
        "text": "Arabic",
        "value": null,
        "nextQuestionId": "383057"
      },
      {
        "id": "1380178",
        "text": "Korean",
        "value": null,
        "nextQuestionId": "383057"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383245": {
    "id": "383245",
    "type": "_freeText",
    "title": "What other languages would you be interested in learning?",
    "description": "Please provide more details.",
    "variable": "futureHobbyLanguageOther",
    "options": [
      {
        "id": "1380180",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383057",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": true
  },
  "383246": {
    "id": "383246",
    "type": "_multiChoice",
    "title": "Which musical instruments are you interested in learning?",
    "description": "Please select all that apply.",
    "variable": "futureHobbyMusic",
    "options": [
      {
        "id": "1380181",
        "text": "Other",
        "value": null,
        "nextQuestionId": "383247"
      },
      {
        "id": "1380182",
        "text": "Guitar",
        "value": null,
        "nextQuestionId": "383057"
      },
      {
        "id": "1380184",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383057",
        "noMatch": true
      },
      {
        "id": "1380183",
        "text": "Piano",
        "value": null,
        "nextQuestionId": "383057"
      },
      {
        "id": "1380185",
        "text": "Violin",
        "value": null,
        "nextQuestionId": "383057"
      },
      {
        "id": "1380186",
        "text": "Drums",
        "value": null,
        "nextQuestionId": "383057"
      },
      {
        "id": "1380187",
        "text": "Ukulele",
        "value": null,
        "nextQuestionId": "383057"
      },
      {
        "id": "1380188",
        "text": "Saxophone",
        "value": null,
        "nextQuestionId": "383057"
      },
      {
        "id": "1380189",
        "text": "Cello",
        "value": null,
        "nextQuestionId": "383057"
      },
      {
        "id": "1380190",
        "text": "Flute",
        "value": null,
        "nextQuestionId": "383057"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383247": {
    "id": "383247",
    "type": "_freeText",
    "title": "What other musical instruments do you want to learn to play?",
    "description": "Please provide more details.",
    "variable": "futureHobbyMusicOther",
    "options": [
      {
        "id": "1380192",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383057",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": true
  },
  "383248": {
    "id": "383248",
    "type": "_multiChoice",
    "title": "Which sports or physical activities are you interested in learning?",
    "description": "Please select all that apply.",
    "variable": "futureHobbySport",
    "options": [
      {
        "id": "1380193",
        "text": "Golf",
        "value": null,
        "nextQuestionId": "383057"
      },
      {
        "id": "1380194",
        "text": "Other",
        "value": null,
        "nextQuestionId": "383249"
      },
      {
        "id": "1380196",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383057",
        "noMatch": true
      },
      {
        "id": "1380195",
        "text": "Tennis",
        "value": null,
        "nextQuestionId": "383057"
      },
      {
        "id": "1380197",
        "text": "Yoga",
        "value": null,
        "nextQuestionId": "383057"
      },
      {
        "id": "1380198",
        "text": "Swimming",
        "value": null,
        "nextQuestionId": "383057"
      },
      {
        "id": "1380199",
        "text": "Running",
        "value": null,
        "nextQuestionId": "383057"
      },
      {
        "id": "1380200",
        "text": "Cycling",
        "value": null,
        "nextQuestionId": "383057"
      },
      {
        "id": "1380201",
        "text": "CrossFit",
        "value": null,
        "nextQuestionId": "383057"
      },
      {
        "id": "1380202",
        "text": "Martial Arts (e.g., karate, judo)",
        "value": null,
        "nextQuestionId": "383057"
      },
      {
        "id": "1380203",
        "text": "General Fitness Training",
        "value": null,
        "nextQuestionId": "383057"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383249": {
    "id": "383249",
    "type": "_freeText",
    "title": "What other sports or physical activities are you interested in learning?",
    "description": "Please provide more details.",
    "variable": "futureHobbySportOther",
    "options": [
      {
        "id": "1380205",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383057",
        "noMatch": true
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": true
  },
  "383250": {
    "id": "383250",
    "type": "_singleChoice",
    "title": "Without overthinking your choice, please select the image that you prefer.",
    "variable": null,
    "options": [
      {
        "id": "1380206",
        "text": "crossroad",
        "value": null,
        "nextQuestionId": "383089",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1702510725054_crossroad_compressed.png"
      },
      {
        "id": "1380207",
        "text": "puzzle",
        "value": null,
        "nextQuestionId": "383089",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1702510725057_puzzle_compressed.png"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383251": {
    "id": "383251",
    "type": "_singleChoice",
    "title": "I prefer a setting where I can have an impact on the thoughts and beliefs of others.",
    "variable": "influenceOthers",
    "options": [
      {
        "id": "1380208",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383210"
      },
      {
        "id": "1380209",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383210"
      },
      {
        "id": "1380210",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383210"
      },
      {
        "id": "1380211",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383210"
      },
      {
        "id": "1380212",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383210"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383252": {
    "id": "383252",
    "type": "_transition",
    "title": "Let's explore your personality.",
    "description": "Please answer these questions as honestly as possible, as this will impact the accuracy of your career report.",
    "variable": null,
    "options": [
      {
        "id": "1380213",
        "text": "Image",
        "value": null,
        "nextQuestionId": "383233",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1692058301484_Different_People_Image_Reduced.jpg"
      }
    ],
    "branching": false,
    "skipping": false,
    "autoAdvance": true
  },
  "383265": {
    "id": "383265",
    "type": "_singleChoice",
    "title": "Would you consider working with a career coach to guide you to success?",
    "description": "On average, professionals who work with a career coach achieve their goals twice as quickly as those who don't.",
    "variable": "careerCoach",
    "options": [
      {
        "id": "1380264",
        "text": "Yes, I'm open to expert coaching.",
        "value": "yes",
        "nextQuestionId": "383266"
      },
      {
        "id": "1380265",
        "text": "No, I would prefer to navigate my career independently.",
        "value": "no",
        "nextQuestionId": "383137"
      },
      {
        "id": "1380266",
        "text": "I'm unsure at this time.",
        "value": "neutral",
        "nextQuestionId": "383137"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383266": {
    "id": "383266",
    "type": "_multiChoice",
    "title": "Which aspects of your professional development would you like to advance with the guidance of a career coach?",
    "description": "Choose the areas you're interested in to help us pair you with a coach who best fits your needs.",
    "variable": "careerCoachService",
    "options": [
      {
        "id": "1380267",
        "text": "",
        "value": null,
        "nextQuestionId": "383137"
      },
      {
        "id": "1380268",
        "text": "Enhancing Your Resume",
        "value": null,
        "nextQuestionId": "383137"
      },
      {
        "id": "1380270",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383137",
        "noMatch": true
      },
      {
        "id": "1380269",
        "text": "Optimizing Your LinkedIn Profile",
        "value": null,
        "nextQuestionId": "383137"
      },
      {
        "id": "1380271",
        "text": "Crafting Your Cover Letter",
        "value": null,
        "nextQuestionId": "383137"
      },
      {
        "id": "1380272",
        "text": "Preparing for Interviews",
        "value": null,
        "nextQuestionId": "383137"
      },
      {
        "id": "1380273",
        "text": "Guidance on Career Direction",
        "value": null,
        "nextQuestionId": "383137"
      },
      {
        "id": "1380274",
        "text": "Developing a Job Search Plan",
        "value": null,
        "nextQuestionId": "383137"
      },
      {
        "id": "1380275",
        "text": "Building Networking Skills and Strategies",
        "value": null,
        "nextQuestionId": "383137"
      },
      {
        "id": "1380276",
        "text": "Coaching for Effective Negotiation",
        "value": null,
        "nextQuestionId": "383137"
      },
      {
        "id": "1380277",
        "text": "Career Change Support",
        "value": null,
        "nextQuestionId": "383137"
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": true
  },
  "383267": {
    "id": "383267",
    "type": "_singleChoice",
    "title": "Would you consider pursuing an additional degree to enhance your career prospects? 🎓",
    "description": "On average, each additional degree is associated with a 20% salary increment.",
    "variable": "moreSchoolInterest",
    "options": [
      {
        "id": "1380278",
        "text": "✅ Yes",
        "value": "true",
        "nextQuestionId": "383011"
      },
      {
        "id": "1380279",
        "text": "❌ No",
        "value": "false",
        "nextQuestionId": "383011"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383268": {
    "id": "383268",
    "type": "_singleChoice",
    "title": "Without overthinking your choice, please select the image that you prefer.",
    "variable": null,
    "options": [
      {
        "id": "1380280",
        "text": "support",
        "value": null,
        "nextQuestionId": "383201",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1702511172149_support_compressed.png"
      },
      {
        "id": "1380281",
        "text": "alone",
        "value": null,
        "nextQuestionId": "383201",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1702511172206_alone_compressed.png"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383270": {
    "id": "383270",
    "type": "_singleChoice",
    "title": "What brings you here to take our career test today?",
    "description": "Please select <strong>one option</strong> that best describes your situation.",
    "variable": "testTakingPurpose",
    "options": [
      {
        "id": "1380286",
        "text": "Considering a career change",
        "value": "careerSwitch",
        "nextQuestionId": "383075"
      },
      {
        "id": "1380287",
        "text": "Unsure about my next steps and seeking career guidance",
        "value": "lost",
        "nextQuestionId": "383271"
      },
      {
        "id": "1380288",
        "text": "Returning to the workforce",
        "value": "return",
        "nextQuestionId": "383075"
      },
      {
        "id": "1380289",
        "text": "Aiming for career advancement",
        "value": "advance",
        "nextQuestionId": "383075"
      },
      {
        "id": "1380290",
        "text": "Exploring university/college major options",
        "value": "collegeMajor",
        "nextQuestionId": "383075"
      },
      {
        "id": "1380291",
        "text": "Curious about tech impacts (e.g., AI)",
        "value": "ai",
        "nextQuestionId": "383075"
      },
      {
        "id": "1380292",
        "text": "Other reasons",
        "value": "other",
        "nextQuestionId": "383156"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383271": {
    "id": "383271",
    "type": "_transition",
    "title": "You're not alone in this.",
    "description": "<strong>41% of our users</strong> have expressed being unsure about their next steps, and that's exactly why we created JobTest.org.",
    "variable": null,
    "options": [
      {
        "id": "1380293",
        "text": "Image",
        "value": null,
        "nextQuestionId": "383075",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1710436818053_Feeling_Lost_Interstitial_Image_500x350.png"
      }
    ],
    "branching": false,
    "skipping": false,
    "autoAdvance": true
  },
  "383272": {
    "id": "383272",
    "type": "_singleChoice",
    "title": "Which of the following is most critical for your dream job to have?",
    "description": "Please choose the <strong>one </strong>that matters the most to you.",
    "variable": "idealCareerFeature",
    "options": [
      {
        "id": "1380294",
        "text": "Excellent work-life balance",
        "value": "balance",
        "nextQuestionId": "383155"
      },
      {
        "id": "1380295",
        "text": "Alignment with my personality traits",
        "value": "compatibility",
        "nextQuestionId": "383155"
      },
      {
        "id": "1380296",
        "text": "Competitive compensation and benefits",
        "value": "compensation",
        "nextQuestionId": "383155"
      },
      {
        "id": "1380297",
        "text": "Positive and inclusive work environment",
        "value": "culture",
        "nextQuestionId": "383155"
      },
      {
        "id": "1380298",
        "text": "Making a positive impact on others",
        "value": "positiveImpact",
        "nextQuestionId": "383155"
      },
      {
        "id": "1380299",
        "text": "Creative freedom and autonomy",
        "value": "autonomy",
        "nextQuestionId": "383155"
      },
      {
        "id": "1380300",
        "text": "Job security and autonomy",
        "value": "security",
        "nextQuestionId": "383155"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383273": {
    "id": "383273",
    "type": "_singleChoice",
    "title": "What do you value most in your working life?",
    "description": "You may value several, but select the one that’s <strong>your top priority.</strong>",
    "variable": "jobMotivation",
    "options": [
      {
        "id": "1380301",
        "text": "Finding fulfillment in my work",
        "value": "satisfaction",
        "nextQuestionId": "382990"
      },
      {
        "id": "1380302",
        "text": "High income and financial rewards",
        "value": "money",
        "nextQuestionId": "382990"
      },
      {
        "id": "1380303",
        "text": "Aligning my career with my personal values",
        "value": "value",
        "nextQuestionId": "382990"
      },
      {
        "id": "1380304",
        "text": "Receiving recognition and respect",
        "value": "fame",
        "nextQuestionId": "382990"
      },
      {
        "id": "1380305",
        "text": "Opportunities for growth",
        "value": "growth",
        "nextQuestionId": "382990"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383274": {
    "id": "383274",
    "type": "_multiChoice",
    "title": "We're sorry to hear that. Could you share what you found most lacking in other tests?",
    "variable": null,
    "options": [
      {
        "id": "1380306",
        "text": "Results were too generic",
        "value": null,
        "nextQuestionId": "383270"
      },
      {
        "id": "1380307",
        "text": "Didn't reflect my true interests or skills",
        "value": null,
        "nextQuestionId": "383270"
      },
      {
        "id": "1380308",
        "text": "Lacked actionable advice",
        "value": null,
        "nextQuestionId": "383270"
      },
      {
        "id": "1380309",
        "text": "Felt impersonal or automated",
        "value": null,
        "nextQuestionId": "383270"
      },
      {
        "id": "1380310",
        "text": "Other reasons",
        "value": null,
        "nextQuestionId": "383270"
      }
    ],
    "branching": false,
    "skipping": true,
    "autoAdvance": true
  },
  "383275": {
    "id": "383275",
    "type": "_transition",
    "title": "That's not unusual.",
    "description": "Most of our users have indicated that their personality can change based on interactions.",
    "variable": null,
    "options": [
      {
        "id": "1380311",
        "text": "Image",
        "value": null,
        "nextQuestionId": "383154",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1710437825772_Personality_Change_Image_540x540.png"
      }
    ],
    "branching": false,
    "skipping": false,
    "autoAdvance": true
  },
  "383276": {
    "id": "383276",
    "type": "_singleChoice",
    "title": "⚠️ Are you sure you want to skip?",
    "description": "Over <strong>92% of JobTest.org users </strong>believe a good career-personality fit is crucial for career satisfaction.",
    "variable": "personalitySkipped",
    "options": [
      {
        "id": "1380312",
        "text": "🔄 OK, let's explore my personality.",
        "value": "false",
        "nextQuestionId": "383252"
      },
      {
        "id": "1380313",
        "text": "➡️ I want to skip this section.",
        "value": "true",
        "nextQuestionId": "383277"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383277": {
    "id": "383277",
    "type": "_singleChoice",
    "title": "Please pick the statement that best represents you.",
    "description": "This quick summary of your personality will help guide us, even if it's not the complete picture.",
    "variable": "capboiShort",
    "options": [
      {
        "id": "1380314",
        "text": "I'm practical and enjoy hands-on tasks. I find fulfillment working with tools and machines and enjoy spending time outdoors. I value practicality and direct results in my work.",
        "value": "pragmatic",
        "nextQuestionId": "383278"
      },
      {
        "id": "1380315",
        "text": "I'm curious and enjoy solving complex problems. I thrive on analyzing, researching, and understanding new concepts, particularly involving science or technology.",
        "value": "analytical",
        "nextQuestionId": "383278"
      },
      {
        "id": "1380316",
        "text": "I'm drawn to creative expression and value innovation and originality. I thrive in environments that encourage individuality and artistic freedom.",
        "value": "imaginative",
        "nextQuestionId": "383278"
      },
      {
        "id": "1380317",
        "text": "I find satisfaction in helping or teaching others. I enjoy interacting with people and making a difference in their lives.",
        "value": "communal",
        "nextQuestionId": "383278"
      },
      {
        "id": "1380318",
        "text": "I enjoy leading, persuading, and influencing outcomes. I'm ambitious, enjoy challenges, and thrive in decision-making roles.",
        "value": "bold",
        "nextQuestionId": "383278"
      },
      {
        "id": "1380319",
        "text": "I value structure and precision in my work. I enjoy tasks that involve data or systematic processes and prefer roles that require efficiency and attention to detail.",
        "value": "orthodox",
        "nextQuestionId": "383278"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383278": {
    "id": "383278",
    "type": "_transition",
    "title": "Next, we'll ask you a series of questions to assess your core strengths.",
    "description": "Please choose how strongly you agree or disagree with each statement.",
    "variable": null,
    "options": [
      {
        "id": "1380320",
        "text": "Image",
        "value": null,
        "nextQuestionId": "383279"
      }
    ],
    "branching": false,
    "skipping": false,
    "autoAdvance": true
  },
  "383279": {
    "id": "383279",
    "type": "_singleChoice",
    "title": "I have a strong attention to detail and can complete tasks with a high level of accuracy and precision.",
    "variable": "attentionToDetailScore",
    "options": [
      {
        "id": "1380321",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383150"
      },
      {
        "id": "1380322",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383150"
      },
      {
        "id": "1380323",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383150"
      },
      {
        "id": "1380324",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383150"
      },
      {
        "id": "1380325",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383150"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383281": {
    "id": "383281",
    "type": "_singleChoice",
    "title": "I have excellent written and verbal communication skills.",
    "variable": "communicationSkillsScore",
    "options": [
      {
        "id": "1380331",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383237"
      },
      {
        "id": "1380332",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383237"
      },
      {
        "id": "1380333",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383237"
      },
      {
        "id": "1380334",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383237"
      },
      {
        "id": "1380335",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383237"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383282": {
    "id": "383282",
    "type": "_singleChoice",
    "title": "I am skilled at strategic thinking and long-term planning.",
    "variable": "strategicThinkingScore",
    "options": [
      {
        "id": "1380336",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383171"
      },
      {
        "id": "1380337",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383171"
      },
      {
        "id": "1380338",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383171"
      },
      {
        "id": "1380339",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383171"
      },
      {
        "id": "1380340",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383171"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383283": {
    "id": "383283",
    "type": "_transition",
    "title": "How Do You Compare With Other JobTest.org Users?",
    "description": "You rank in the top <strong>10%</strong> in decision-making abilities. Your capacity to excel in uncertain situations sets you apart from your peers.",
    "variable": null,
    "options": [
      {
        "id": "1380341",
        "text": "Image",
        "value": null,
        "nextQuestionId": "383185",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1692061389493_Decision-Making.png"
      }
    ],
    "branching": false,
    "skipping": false,
    "autoAdvance": true
  },
  "383284": {
    "id": "383284",
    "type": "_transition",
    "title": "💡 Did you know?",
    "description": "Over half of American workers say they are unhappy with their current job. Jobs reported as \"least satisfying\" include roofer, bartender, and cashier.",
    "variable": null,
    "options": [
      {
        "id": "1380342",
        "text": "Image",
        "value": null,
        "nextQuestionId": "383190",
        "imageUrl": "https://qubl-images.s3.us-east-2.amazonaws.com/prod/answers/1695132346376_time.gif"
      }
    ],
    "branching": false,
    "skipping": false,
    "autoAdvance": true
  },
  "383285": {
    "id": "383285",
    "type": "_singleChoice",
    "title": "I am able to manage a team effectively and can delegate tasks.",
    "variable": "teamManagementScore",
    "options": [
      {
        "id": "1380343",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383183"
      },
      {
        "id": "1380344",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383183"
      },
      {
        "id": "1380345",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383183"
      },
      {
        "id": "1380346",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383183"
      },
      {
        "id": "1380347",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383183"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383286": {
    "id": "383286",
    "type": "_singleChoice",
    "title": "My work must have a positive impact on others.",
    "variable": "positiveImpact",
    "options": [
      {
        "id": "1380348",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383287"
      },
      {
        "id": "1380349",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383287"
      },
      {
        "id": "1380350",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383287"
      },
      {
        "id": "1380351",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383287"
      },
      {
        "id": "1380352",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383287"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383287": {
    "id": "383287",
    "type": "_singleChoice",
    "title": "I enjoy trying to understand people and their motivations.",
    "variable": "peopleMotivationsInterest",
    "options": [
      {
        "id": "1380353",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383288"
      },
      {
        "id": "1380354",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383288"
      },
      {
        "id": "1380355",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383288"
      },
      {
        "id": "1380356",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383288"
      },
      {
        "id": "1380357",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383288"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383288": {
    "id": "383288",
    "type": "_singleChoice",
    "title": "I enjoy doing extensive research to gain a thorough understanding of a topic.",
    "variable": "enjoysExtensiveResearch",
    "options": [
      {
        "id": "1380358",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383289"
      },
      {
        "id": "1380359",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383289"
      },
      {
        "id": "1380360",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383289"
      },
      {
        "id": "1380361",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383289"
      },
      {
        "id": "1380362",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383289"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383289": {
    "id": "383289",
    "type": "_singleChoice",
    "title": "I flourish when I can demonstrate my talents and abilities in a competitive atmosphere.",
    "variable": "competitiveEnvironment",
    "options": [
      {
        "id": "1380363",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383228"
      },
      {
        "id": "1380364",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383228"
      },
      {
        "id": "1380365",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383228"
      },
      {
        "id": "1380366",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383228"
      },
      {
        "id": "1380367",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383228"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383290": {
    "id": "383290",
    "type": "_singleChoice",
    "title": "I have excellent attention to detail.",
    "variable": "greatAttentionToDetail",
    "options": [
      {
        "id": "1380368",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383187"
      },
      {
        "id": "1380369",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383187"
      },
      {
        "id": "1380370",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383187"
      },
      {
        "id": "1380371",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383187"
      },
      {
        "id": "1380372",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383187"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383291": {
    "id": "383291",
    "type": "_singleChoice",
    "title": "I am skilled at analyzing and drawing conclusions from data.",
    "variable": "dataAnalysisScore",
    "options": [
      {
        "id": "1380373",
        "text": "Strongly Disagree",
        "value": "1",
        "nextQuestionId": "383178"
      },
      {
        "id": "1380374",
        "text": "Disagree",
        "value": "2",
        "nextQuestionId": "383178"
      },
      {
        "id": "1380375",
        "text": "Neutral",
        "value": "3",
        "nextQuestionId": "383178"
      },
      {
        "id": "1380376",
        "text": "Agree",
        "value": "4",
        "nextQuestionId": "383178"
      },
      {
        "id": "1380377",
        "text": "Strongly Agree",
        "value": "5",
        "nextQuestionId": "383099"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383292": {
    "id": "383292",
    "type": "_multiChoice",
    "title": "Are you responsible for caring for any of the following?",
    "description": "Select all that apply.",
    "variable": "guardianStatus",
    "options": [
      {
        "id": "1380378",
        "text": "Child or Children",
        "value": null,
        "nextQuestionId": "383091"
      },
      {
        "id": "1380381",
        "text": "Pet or Pets",
        "value": null,
        "nextQuestionId": "383091"
      },
      {
        "id": "1380382",
        "text": "Other Dependents (eg elderly family members)",
        "value": null,
        "nextQuestionId": "383091"
      },
      {
        "id": "1380384",
        "text": "None of the Above",
        "value": null,
        "nextQuestionId": "383091"
      },
      {
        "id": "1380385",
        "text": "No Match",
        "value": null,
        "nextQuestionId": "383091",
        "noMatch": true
      }
    ],
    "branching": true,
    "skipping": true,
    "autoAdvance": true
  },
  "383293": {
    "id": "383293",
    "type": "_singleChoice",
    "title": "Do you want us to also recommend temporary jobs while you prepare for your ideal career?",
    "description": "A temporary job could close the employment gap between now and the start of your new career journey. Clicking \"Yes\" <strong>will NOT </strong>affect your career results.",
    "variable": "temporaryJobInterest",
    "options": [
      {
        "id": "1380386",
        "text": "Yes",
        "value": "true",
        "nextQuestionId": "383292"
      },
      {
        "id": "1380387",
        "text": "No",
        "value": "false",
        "nextQuestionId": "383292"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383294": {
    "id": "383294",
    "type": "_singleChoice",
    "title": "How much are you thinking about AI's impact on your career?",
    "description": "Up to 40% of jobs could be affected by AI.",
    "variable": "aiImpactConcern",
    "options": [
      {
        "id": "1380388",
        "text": "I'm worried about it",
        "value": "4",
        "nextQuestionId": "383295"
      },
      {
        "id": "1380389",
        "text": "I've thought about it",
        "value": "3",
        "nextQuestionId": "383295"
      },
      {
        "id": "1380390",
        "text": "I'm curious but not concerned",
        "value": "2",
        "nextQuestionId": "383295"
      },
      {
        "id": "1380391",
        "text": "I haven't thought about it",
        "value": "1",
        "nextQuestionId": "383295"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "383295": {
    "id": "383295",
    "type": "_singleChoice",
    "title": "Want to see your personalized AI Risk Score?",
    "description": "A score that shows how exposed your career may be to AI, and what to do about it.",
    "variable": "aiRiskScoreInterest",
    "options": [
      {
        "id": "1380392",
        "text": "Yes",
        "value": "true",
        "nextQuestionId": "383024"
      },
      {
        "id": "1380393",
        "text": "No",
        "value": "false",
        "nextQuestionId": "383024"
      }
    ],
    "branching": true,
    "skipping": false,
    "autoAdvance": true
  },
  "999001": {
    "id": "999001",
    "type": "_singleChoice",
    "title": "What is your gender?",
    "description": "Helps us connect you with relevant coaches and communities. Your answer is private and never shared.",
    "variable": "gender",
    "options": [
      {
        "id": "9990011",
        "text": "Female",
        "value": "female",
        "nextQuestionId": "383217"
      },
      {
        "id": "9990012",
        "text": "Male",
        "value": "male",
        "nextQuestionId": "383217"
      },
      {
        "id": "9990013",
        "text": "Non-binary",
        "value": "nonbinary",
        "nextQuestionId": "383217"
      },
      {
        "id": "9990014",
        "text": "Prefer not to answer",
        "value": "private",
        "nextQuestionId": "383217"
      }
    ],
    "branching": false,
    "skipping": false,
    "autoAdvance": true
  }
};

const ORDER: string[] = ["383020","383158","383157","383274","383270","383271","383156","383075","383074","383073","383072","383071","383235","383272","383155","383275","383154","383273","382990","383033","383153","383276","383252","383277","383233","383209","383225","383227","383230","383284","383190","383286","383287","383288","383289","383228","383290","383187","383226","383208","383013","383101","383100","383117","383102","383189","383133","383251","383210","383202","383129","383191","383250","383089","383088","383268","383201","383229","383204","383151","383203","383232","383077","383194","383142","383188","383231","383207","383152","383148","383147","383211","383244","383248","383246","383058","383245","383249","383247","383057","383221","383278","383279","383150","383149","383023","383281","383237","383282","383171","383283","383185","383184","383285","383183","383182","383181","383022","383180","383179","383291","383099","383178","383177","383176","383161","383175","383174","383173","383224","383223","383222","383090","382989","383212","383213","383015","383094","383037","383293","383206","383292","383091","383093","383125","383018","383164","383056","383166","383167","383009","383008","383007","383017","383103","383172","383218","382985","383006","382984","383005","383004","383003","383002","383001","383000","382999","383236","382998","382997","382996","382995","382994","383043","383044","383095","383104","383107","383080","383141","383105","383267","383011","383146","383145","383115","383010","383265","383266","383137","383021","383140","383139","383028","383032","383031","383030","383029","383027","383026","383216","383025","383144","383163","383016","383040","999001","383217","383076","383234","383070","383138","382992","383294","383295","383024"];

export const QUIZ: QuizManifest = {
  version: "2026-10-14T21:43:13.854Z",
  entryQuestionId: "383020",
  terminalQuestionId: "383024",
  questions: QUESTIONS,
  questionOrder: ORDER,
};
